function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', 'false');

  if(summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};
var mncont = false;
function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch(e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if(navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused'); 

  }, true);
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true })

    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function(selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
};

Shopify.postLink = function(path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for(var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
  this.countryEl         = document.getElementById(country_domid);
  this.provinceEl        = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler,this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function() {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function(e) {
    var opt       = this.countryEl.options[this.countryEl.selectedIndex];
    var raw       = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function(selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    if (navigator.platform === 'iPhone') document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    this.querySelectorAll('button:not(.close-menu-js)').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
    this.querySelectorAll('.close-menu-js').forEach(button => button.addEventListener('click', this.onMenuCloseButtonClick.bind(this)));
  }
  onMenuCloseButtonClick(){
    this.querySelector('.main-menu-button').dispatchEvent(new Event('click'));
  }
  onKeyUp(event) {
    if(event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if(!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if(isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches ? addTrapFocus() : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
	document.body.setAttribute('data-top', window.pageYOffset);
	document.body.style.top = `-${window.pageYOffset}px`;
	document.body.classList.add(`fixed-position`);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach(details => {
      setTimeout(() => {
        details.removeAttribute('open');
        details.classList.remove('menu-opening');
      }, 200);
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach(submenu => {
      submenu.classList.remove('submenu-open');
    });

	var scrollPosition = document.body.getAttribute('data-top');
    document.body.style.removeProperty('top');
	document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
	document.body.classList.remove(`fixed-position`);
    const sticky = document.querySelector('sticky-header')
    if(sticky){
      document.body.classList.add(`close_drawer_menu`);
    }
    window.scrollTo({
      top: scrollPosition,
      behavior: "instant"
    });

    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    }

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);
class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector('.section-header');
    this.borderOffset = 0;
    document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);

	document.body.setAttribute('data-top', window.pageYOffset);
	document.body.style.top = `-${window.pageYOffset}px`;
	document.body.classList.add(`fixed-position`);
	document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
  }
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]') && this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this)
    );
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      
      this.addEventListener('click', (event) => {
        if (event.hasOwnProperty('path') && event.path[0].className === 'popup-modal') this.hide();
      });
      this.addEventListener('touchstart', (event) => {
        if (event.target.className === 'popup-modal' && event.target.id != "age-verification-popup") this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    const focuselement = this.querySelector('[tabindex]');
    document.body.style.paddingRight = this.getScrollbarWidth() + 'px';
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
	var intervalForFocus = setTimeout(function(){focuselement && focuselement.focus();},100);
    window.pauseAllMedia();
    intervalForFocus = false;
  }

  hide() {
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
    setTimeout(function(){
      document.body.classList.remove('overflow-hidden');
      document.body.dispatchEvent(new CustomEvent('modalClosed'));
      document.body.style.paddingRight = '';
    }, 200)
  }
  getScrollbarWidth() {
    return window.innerWidth - document.documentElement.clientWidth;
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
    }
  }
}
customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();

    this.rtl = document.documentElement.hasAttribute("dir");
    if (this.classList.contains('slider-desktop')){
      this.moving = false;
      setTimeout(this.sliderDesktop.bind(this), 100);
    }

    if (this.classList.contains('slider-desktop') || (!this.classList.contains('slider') && !this.classList.contains('slider-js'))){
      var wrapper = document.createElement('div');
      wrapper.classList.add('slider__overflow-hidden--phone');
      this.parentNode.insertBefore(wrapper, this);
      wrapper.appendChild(this);
    }

    if (!this.classList.contains('slider') && !this.classList.contains('slider-js')) return;
    if (this.classList.contains('slider-js')){
      this.slider = this.querySelectorAll('.slider')[0];
    }
    else{
      this.slider = this;
    }

    this.sliderItems = this.querySelectorAll('.slider__slide');
    const parentElement = this.parentElement.parentElement.parentElement;
    this.buttons = parentElement.querySelectorAll('.slider__buttons button');
    this.buttons_thumb = parentElement.querySelector('.slider__buttons');
    
    if (!this.buttons.length) return;

    this.buttons_thumb = this.buttons_thumb.classList.contains('slider__buttons--slider');
    if(this.buttons_thumb){
      this.thumbnail_list = parentElement.querySelector('.thumbnail-slider__list');
    }
    
    this.slider.toscroll = Math.round(this.sliderItems.length/this.buttons.length);

    !this.buttons_thumb && this.buttons.forEach(button => {
      button.addEventListener('click', this.onButtonClick.bind(this));
    });
   
    this.initPages();

    this.slider.addEventListener('scroll', this.update.bind(this));
  }

  sliderDesktop(){
    this.windowWidth = -1000000;
    const _parent = this.closest('.featured-collection-items');
    this.desktop_button_prev = _parent.querySelector(".slider-desktop__buttons__prev");
    this.desktop_button_next = _parent.querySelector(".slider-desktop__buttons__next");
    this.desktop_item = this.lastChild;

    this.resizeHandlerSliderDesktop();
    
    this.desktop_button_prev.addEventListener('click', this.desktopButtonPrev.bind(this));
    this.desktop_button_next.addEventListener('click', this.desktopButtonNext.bind(this));
    window.addEventListener("resize", this.resizeHandlerSliderDesktop.bind(this), false);

    
    this.parentNode.addEventListener('touchstart', this.touchstartHandler.bind(this));
    this.closest('.featured-collection-items').addEventListener('touchmove', this.touchemoveHandler.bind(this));
	this.closest('.featured-collection-items').addEventListener('touchend', this.touchendHandler.bind(this));
	this.parentNode.addEventListener('mousedown', this.mousedownHandler.bind(this));
    this.closest('.featured-collection-items').addEventListener('mousemove', this.mousemoveHandler.bind(this));
	this.closest('.featured-collection-items').addEventListener('click', this.mouseupHandler.bind(this));
    this.closest('.featured-collection-items').addEventListener('mouseleave', this.mouseupHandler.bind(this));
  }
  resizeHandlerSliderDesktop(){
    this.desktop_item_width = this.lastChild.offsetWidth;
    if(this.windowWidth == window.innerWidth || this.desktop_item_width == 0) return;
    this.windowWidth = window.innerWidth;
    this.scroll_all_page = !(this.classList.contains("slider-desktop--scroll-one")&&!("ontouchstart" in document.documentElement));
    this.setAttribute('data-page', 0);
    this.visible_items = Math.round(this.parentElement.offsetWidth / this.desktop_item.offsetWidth);
    this.desktop_pages = this.scroll_all_page ? Math.ceil(this.children.length / this.visible_items) - 1 : this.children.length - this.visible_items;
    this.visible_items_width = this.visible_items * this.desktop_item.offsetWidth;
    this.minimal_value = Number(this.desktop_item.getBoundingClientRect().left - this.getBoundingClientRect().left - this.visible_items_width + this.desktop_item_width) * -1;
    if(this.rtl){
      var page = this.desktop_pages;
      var diff = this.children.length - (page + 1) * this.visible_items;
      var index = diff >= 0 ? page * this.visible_items : this.children.length - diff * -1 - (this.visible_items - diff * -1);
      index = diff >= 0 ? Math.min((page+1) * this.visible_items-1, this.children.length-1) : this.children.length-1;
      this.minimal_value = this.children[index].offsetLeft;
    }
    this.desktopButtonPrev();
    this.desktop_button_prev.classList.add('slider-desktop__buttons__hide');
    this.desktop_pages > 0 ? this.desktop_button_next.classList.remove('slider-desktop__buttons__hide') : this.desktop_button_next.classList.add('slider-desktop__buttons__hide');
    this.scroll_step = this.scroll_all_page ? this.desktop_item_width * this.visible_items : this.desktop_item_width;
    this.visible_items > this.children.length ? this.classList.add('justify-content-center-js') : this.classList.remove('justify-content-center-js');
    this.classList.remove('slider-desktop--hide-items');
  }
  desktopButtonPrev(){
    var scroll_step = this.scroll_step,
        page = Math.max(Number(this.getAttribute('data-page')) - 1, 0),
        val = Math.round(Math.min(scroll_step * page * -1, 0));

    if(this.rtl){
      val = Math.round(Math.min(scroll_step * page * -1, 0)) * -1;
    }

    this.style.transform = `translate3d(${val}px, 0px, 0px)`;
    this.setAttribute('data-page', page);
    page == 0 && this.desktop_button_prev.classList.add('slider-desktop__buttons__hide');
    page < this.desktop_pages && this.desktop_button_next.classList.remove('slider-desktop__buttons__hide');
  }
  desktopButtonNext(){
    var scroll_step = this.scroll_step,
        page = Math.min(Number(this.getAttribute('data-page')) + 1, this.desktop_pages),
        val = Math.round(Math.max(scroll_step * page * -1, this.minimal_value));

    if(this.rtl){
      val = val*-1;
    }
    
    this.style.transform = `translate3d(${val}px, 0px, 0px)`;
    this.setAttribute('data-page', page);
    page > 0 && this.desktop_button_prev.classList.remove('slider-desktop__buttons__hide');
    page == this.desktop_pages && this.desktop_button_next.classList.add('slider-desktop__buttons__hide');
  }
  touchstartHandler(event){
    if(window.innerWidth <= 576 || this.children.length <= this.visible_items) return false;
	this.mouse_position_on_click = event.touches[0].clientX;
    this.mouse_clientY = window.scrollY;
    this.moving = true;
    this.classList.add('slider-desktop-no-animations');
  }
  touchemoveHandler(event){
    if(!this.moving) return false;
    var scroll = event.touches[0].clientX - this.mouse_position_on_click,
        page = Number(this.getAttribute('data-page')),
        val = 0;
    if(this.scroll_all_page){
      scroll = scroll > 0 ? Math.min(scroll, window.innerWidth) : Math.max(scroll, window.innerWidth * -1);
      var diff = this.children.length - (page + 1) * this.visible_items;
      var index = diff >= 0 ? page * this.visible_items : this.children.length - diff * -1 - (this.visible_items - diff * -1);
      if(this.rtl){
        index = diff >= 0 ? Math.min((page+1) * this.visible_items-1, this.children.length-1) : this.children.length-1;
      }
      val = this.children[index].offsetLeft  * -1 + scroll;
      if(!this.rtl){
        val = Math.max(val, this.minimal_value - window.innerWidth / 4);
        val = Math.min(val, window.innerWidth / 4);
      }
    }
    else{
      scroll = scroll > 0 ? Math.min(scroll, this.desktop_item_width) : Math.max(scroll, this.desktop_item_width * -1);
      scroll = this.rtl ? scroll*-1:scroll;
      val = this.scroll_step * page * -1 + scroll;
      if(this.rtl){
        val = val*-1;
      }
    }
    this.style.transform = `translate3d(${val}px, 0px, 0px)`;
  }
  touchendHandler(event){
    if(!this.moving) return false;
    this.moving = false;
    this.classList.remove('slider-desktop-no-animations');
    var delta = 100;
    if(this.mouse_position_on_click > event.changedTouches[0].clientX+delta){
	  event.preventDefault();
      this.rtl?this.desktopButtonPrev():this.desktopButtonNext();
    }
    else if(this.mouse_position_on_click < event.changedTouches[0].clientX-delta){
	  event.preventDefault();
      this.rtl?this.desktopButtonNext():this.desktopButtonPrev();
    }
    else{
      var page = Number(this.getAttribute('data-page')),
          val = Math.max(this.scroll_step * page * -1, this.minimal_value);
      if(this.rtl){
        val = val*-1;
      }
      this.style.transform = `translate3d(${val}px, 0px, 0px)`;
    }
  }
  mousedownHandler(event){
    if(event.button != 0 || window.innerWidth <= 576 || this.children.length <= this.visible_items) return false;
	this.mouse_position_on_click = event.screenX;
    this.moving = true;
    this.classList.add('slider-desktop-no-animations');
  }
  mousemoveHandler(event){
    if(!this.moving) return false;
    var scroll = event.screenX - this.mouse_position_on_click,
        page = Number(this.getAttribute('data-page')),
        val = 0;
    if(this.scroll_all_page){
      scroll = scroll > 0 ? Math.min(scroll, window.innerWidth / 2) : Math.max(scroll, window.innerWidth / 2 * -1);
      var diff = this.children.length - (page + 1) * this.visible_items;
      var index = diff >= 0 ? page * this.visible_items : this.children.length - diff * -1 - (this.visible_items - diff * -1);
      if(this.rtl){
        index = diff >= 0 ? Math.min((page+1) * this.visible_items-1, this.children.length-1) : this.children.length-1;
      }
      val = this.children[index].offsetLeft  * -1 + scroll;
    }
    else{
      scroll = scroll > 0 ? Math.min(scroll, this.desktop_item_width) : Math.max(scroll, this.desktop_item_width * -1);
      scroll = this.rtl ? scroll*-1:scroll;
      val = this.scroll_step * page * -1 + scroll;
      if(this.rtl){
        val = val*-1;
      }
    }
    this.style.transform = `translate3d(${val}px, 0px, 0px)`;
  }
  mouseupHandler(event){
    if(!this.moving) return false;
    this.moving = false;
    this.classList.remove('slider-desktop-no-animations');
    var delta = this.desktop_item_width - 50;
    if(this.mouse_position_on_click > event.screenX+delta){
	  event.preventDefault();
      this.rtl?this.desktopButtonPrev():this.desktopButtonNext();
    }
    else if(this.mouse_position_on_click < event.screenX-delta){
	  event.preventDefault();
      this.rtl?this.desktopButtonNext():this.desktopButtonPrev();
    }
    else{
      var page = Number(this.getAttribute('data-page')),
          val = Math.max(this.scroll_step * page * -1, this.minimal_value);
      if(this.rtl){
        val = val*-1;
      }
      this.style.transform = `translate3d(${val}px, 0px, 0px)`;
    }
  }

  initPages() {
    var sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
    sliderItemsToShow = !sliderItemsToShow.length ? Array.from(this.sliderItems) : sliderItemsToShow;
    this.sliderFirstItem = sliderItemsToShow[0];
    this.sliderLastItem = sliderItemsToShow[sliderItemsToShow.length - 1];
    if (sliderItemsToShow.length === 0) return;
    this.slidesPerPage = Math.floor(this.clientWidth / sliderItemsToShow[0].clientWidth);
    this.totalPages = sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('.slider__slide');
    this.initPages();
  }
  
  update() {
    var currentPage = Math.max(this.slider.scrollLeft / this.sliderLastItem.clientWidth / this.slider.toscroll, 0),
        currentElement = "false";

    if(document.documentElement.hasAttribute("dir")){
      currentPage = Math.min(this.slider.scrollLeft / this.sliderLastItem.clientWidth / this.slider.toscroll, 0)*-1
    }
    
    if(this.sliderLastItem.clientWidth == this.slider.offsetWidth){
      currentPage = Math.floor(currentPage);
    }
    else{
      currentPage = currentPage - Math.floor(currentPage) > 0.48 ? Math.ceil(currentPage) : Math.floor(currentPage);
    }
    
    var BreakException = {},
    	index = 0;

    try {
      this.buttons.forEach(button => {
        if(isNaN(currentPage)) return;
        if(button.classList.contains('slider__button')){
          index = Number(Array.prototype.indexOf.call(button.parentElement.children, button));
        }
        else{
          index = Number(Array.prototype.indexOf.call(button.parentElement.parentElement.children, button.parentElement));
        }

        if(currentPage == index && button.classList.contains('slider__button--current')){
          throw BreakException;
        }
        if(currentPage != index && button.classList.contains('slider__button--current')){
          button.classList.remove('slider__button--current');
        }
        if(currentPage == index){
          button.classList.add('slider__button--current');
          currentElement = this.buttons_thumb ? button.parentElement : false;
        }
      })
    }
    catch (e) {
      if (e !== BreakException) throw e;
    };
    
    if(!this.buttons_thumb || currentElement == "false") return;

    if(this.thumbnail_list.scrollLeft+this.slider.offsetWidth<currentElement.offsetLeft+currentElement.offsetWidth){
      this.thumbnail_list.scrollTo({
        left: currentElement.offsetLeft-this.thumbnail_list.offsetWidth+currentElement.offsetWidth - this.sliderFirstItem.offsetLeft
      });
    }
    if(currentElement.offsetLeft<this.thumbnail_list.scrollLeft){
      this.thumbnail_list.scrollTo({
        left: currentElement.offsetLeft - this.sliderFirstItem.offsetLeft
      });
    }
  }

  onButtonClick(event){
    event.preventDefault();
    
    var parent = event.target.parentElement,
    	index = Number(Array.prototype.indexOf.call(parent.children, event.target))*this.slider.toscroll;
    
    if(Shopify.designMode) this.initPages();
    
    var slideScrollPosition = (this.sliderFirstItem.clientWidth+this.sliderFirstItem.offsetLeft*2)*index;

    if(document.documentElement.hasAttribute("dir")){
      if(this.buttons.length == this.childNodes.length){
        slideScrollPosition = slideScrollPosition * -1;
      }
      else{
        slideScrollPosition = slideScrollPosition/2 * -1 + this.sliderFirstItem.clientWidth;
      }
    }
    
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }
}
customElements.define('slider-component', SliderComponent);
class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach(link => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
    this.autoplaySpeed = this.slider.dataset.speed * 1000;

    this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    this.play();
    this.autoplayButtonIsSetToPlay = true;
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach(link => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
    this.play();
  }

  focusInHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
      this.play();
    } else if (this.autoplayButtonIsSetToPlay) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition = this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.slider.querySelector('.slideshow__slide').clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const button = item.querySelector('a');
      if (index === this.currentPage - 1) {
        if (button) button.removeAttribute('tabindex');
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (button) button.setAttribute('tabindex', '-1');
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
    this.stickycartselect = this.classList.contains('sticky-cart-select');
    this.staticUrl = this.classList.contains("variant-radios--static-url");
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.updateVariantStatuses();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true,`product-form-${this.dataset.section}`);
      this.toggleAddButton(true, '', true,`sticky-cart-${this.dataset.section}`);
      this.setUnavailable();
    } else {
      this.updateMedia();
      !this.staticUrl && this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      if(!this.stickycartselect){
        return !variant.options.map((option, index) => {
          return this.options[index] === option;
        }).includes(false);
      }
      else{
      	if(variant.id == this.options[0]) return variant;
      }
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGallery = document.getElementById(`MediaGallery-${this.dataset.section}`);
    mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true);

    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    if(!modalContent) return;
    const newMediaModal = modalContent.querySelector( `[data-media-id="${this.currentVariant.featured_media.id}"]`);
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
      
        function renderProductInfoHandler(id, id_source, _this){
          const html = new DOMParser().parseFromString(responseText, 'text/html')
          const destination = document.getElementById(id);
          const source = html.getElementById(id_source);

          if (source && destination) destination.innerHTML = source.innerHTML;

          const price = document.getElementById(id);

          if (price) price.classList.remove('visibility-hidden');
          _this.toggleAddButton(!_this.currentVariant.available, window.variantStrings.soldOut);
        }
      
      	const dataset_source = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;
      	renderProductInfoHandler(`price-${this.dataset.section}`, `price-${dataset_source}`, this);
      	renderProductInfoHandler(`information-${this.dataset.section}`, `information-${dataset_source}`, this);
      	renderProductInfoHandler(`badge__container-${this.dataset.section}`, `badge__container-${dataset_source}`, this);
      	renderProductInfoHandler(`inventory-${this.dataset.section}`, `inventory-${dataset_source}`, this);
      	renderProductInfoHandler(`sticky-cart-${this.dataset.section}`, `sticky-cart-${dataset_source}`, this);
      
        if(this.stickycartselect){
          renderProductInfoHandler(`variant-radios-${this.dataset.section}`, `variant-radios-${this.dataset.section}`, this);
          renderProductInfoHandler(`variant-selects-${this.dataset.section}`, `variant-selects-${this.dataset.section}`, this);
        }
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true, id) {
    id = id || `product-form-${this.dataset.section}`;
    const productForm = document.getElementById(id);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');

    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    if(button){
      var addButton = button.querySelector('[name="add"]');
      var addButtonText = button.querySelector('[name="add"] > span');
    }
    
    const buttonSticky = document.getElementById(`sticky-cart-${this.dataset.section}`);
    if(buttonSticky){
      var addButtonStickyText = buttonSticky.querySelector('[name="add"] > span');
    }
    
    var price = document.getElementById(`price-${this.dataset.section}`);
    var information = document.getElementById(`information-${this.dataset.section}`);
    var badge__container = document.getElementById(`badge__container-${this.dataset.section}`);
    var inventory = document.getElementById(`inventory-${this.dataset.section}`);
    var stickycartselect = document.getElementById(`sticky-cart-select-${this.dataset.section}`);
    
    
    if (button) addButtonText.textContent = window.variantStrings.unavailable;
    if (buttonSticky){
      addButtonStickyText.textContent = window.variantStrings.unavailable;
    }

    if (price) price.classList.add('visibility-hidden');
    if (information) information.classList.add('visibility-hidden');
    if (badge__container) badge__container.classList.add('visibility-hidden');
    if (inventory) inventory.classList.add('visibility-hidden');
    if (stickycartselect) stickycartselect.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(
      (variant) => this.querySelector(':checked').value === variant.option1
    );
    const inputWrappers = [...this.querySelectorAll('.product-form__input')];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [...option.querySelectorAll('input[type="radio"], option')];
      const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
      const availableOptionInputsValue = selectedOptionOneVariants
        .filter((variant) => variant.available && variant[`option${index}`] === previousOptionSelected)
        .map((variantOption) => variantOption[`option${index + 1}`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue);
    });
  }
}
customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.classList.remove('disabled');
      } else {
        input.classList.add('disabled');
      }
    });
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);

class fullscreenObject extends HTMLElement {
  constructor() {
    super();
    this.resizeHandler();
    setTimeout(this.resizeHandler.bind(this), 500);
    window.addEventListener("resize", this.resizeHandler.bind(this), false);
  }
  resizeHandler(){
    var intViewportWidth = window.innerWidth,
    	intViewportHeight = window.innerHeight,
    	child = this.closest('section'),
        parent = child.parentNode,
        index = Array.prototype.indexOf.call(parent.children, child),
        bottom_padding = Number(this.hasAttribute('data-bottom-padding') ? this.getAttribute('data-bottom-padding') : 0),
        breadcrumb = document.querySelectorAll('.breadcrumb');

    if(intViewportWidth <= 992){
      this.style.height = 'auto';
    }
    else{
      if(index == 0 || index == 1 && breadcrumb.length)
      this.style.height = intViewportHeight - child.offsetTop - bottom_padding +'px'
      else
      this.style.height = intViewportHeight - bottom_padding + 'px'
	}
  }
}
customElements.define('fullscreen-object', fullscreenObject);

class toggleAnimation extends HTMLElement {
  constructor() {
    super();
    
    if(this.classList.contains('admin-panel--no-js')) return;

    this.accordion = 'chm-toggle--accordion',
	this.toggleClass = '.chm-toggle',
	this.toggleContent = '.chm-toggle__content';
    this.boxes = this.querySelectorAll('summary');

    if(!this.boxes.length) return;
    this.bindEvents();
    this.resizeHandler();
    window.addEventListener("resize", this.resizeHandler.bind(this), false);
  }
  bindEvents(){
    const _this = this;
    this.boxes.forEach(box => {
      box.addEventListener('click', event => {
        event.preventDefault();
        var details = event.target.closest(_this.toggleClass),
            content = details.querySelector(_this.toggleContent),
            childs = _this.querySelectorAll('[open]');
        if(details.hasAttribute('open')){
          details.classList.remove('toggle-opening');
          if(!_this.classList.contains(_this.accordion)){
            setTimeout(function(){
              details.removeAttribute('open');
            }, 300);
            return false;
          }
        }
        else{
          details.setAttribute('open', '');
          setTimeout(function(){
            _this.resizeHandler();
            details.classList.add('toggle-opening');
          }, 0);
        }
        if(childs.lenght <= 0 || !_this.classList.contains(_this.accordion)) return false;
        childs.forEach(child => {
          child.classList.remove('toggle-opening');
          setTimeout(function(){
            child.removeAttribute('open');
          }, 300);
        });
      });
    });
  }
  resizeHandler(){
   	const boxes = this.querySelectorAll('[open] '+this.toggleContent);
	boxes.forEach(box => {
      box.style.setProperty('--scroll-height', (box.scrollHeight+1) + "px");
    });
  }
}
customElements.define('toggle-component', toggleAnimation);
function setCookie(d,e,b){var c="";if(b){var a=new Date;a.setTime(a.getTime()+864e5*b),c="; expires="+a.toUTCString()}document.cookie=d+"="+(e||"")+c+"; path=/"}function getCookie(e){for(var c=e+"=",d=document.cookie.split(";"),b=0;b<d.length;b++){for(var a=d[b];" "==a.charAt(0);)a=a.substring(1,a.length);if(0==a.indexOf(c))return a.substring(c.length,a.length)}return null}function eraseCookie(a){document.cookie=a+"=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;"}
class mapSectionHandler extends HTMLElement {
  constructor() {
    super();
    this.map_src = "https://maps.googleapis.com/maps/api/js?sensor=false&key="+this.getAttribute('data-api-key');
    this.zoom_level = this.getAttribute('data-zoom-level');
    this.map_address = this.getAttribute('data-map-address');
    this.show_pin = this.getAttribute('data-show-pin') == "true"?true:false;

	window.addEventListener('mapLoaded', this.initMap.bind(this), false);
    
    var scripts = document.querySelectorAll('[src*="'+this.map_src+'"]');
    if(!scripts.length || Shopify.designMode) this.loadMapScript();
  }
  loadMapScript(){
    var map_script = document.createElement('script');
    map_script.setAttribute('src',this.map_src);
    this.parentElement.appendChild(map_script);
    map_script.onload = () => {
      window.dispatchEvent(event_map_loaded);
    }
  }
  initMap(){
    var show_pin = this.show_pin;
    var mapOptions = {
      zoom: Number(this.zoom_level),
      scrollwheel:  false,
      styles: []
    };
    if(this.map_address == ''){
      mapOptions.center = {lat: -34.397, lng: 150.644};
    }
    var mapElement = this;
    var map = new google.maps.Map(mapElement, mapOptions);
    
    var geocoder = new google.maps.Geocoder();
    var marker = new google.maps.Marker({map});

    function clear() {
      marker.setMap(null);
    }
    function geocode(request) {
      clear();
      geocoder
      .geocode(request)
      .then((result) => {
        const { results } = result;
        map.setCenter(results[0].geometry.location);
        if(show_pin){
          marker.setPosition(results[0].geometry.location);
          marker.setMap(map);
        }
        return results;
      })
      .catch((e) => {
        console.log("Geocode was not successful for the following reason: " + e);
      });
    }
    
    geocode({ address: this.map_address });
  }
}
const event_map_loaded = new Event('mapLoaded');
customElements.define('map-section', mapSectionHandler);

class progressCircle extends HTMLElement {
  constructor() {
    super();
    this.full_time = Number(this.getAttribute("data-duration"));
    this.percent_text = this.querySelector("[data-percent]");
    this.percent = Number(this.percent_text.getAttribute("data-percent"));
    this.percentStart = 0;
    this.progressDelay = 0;
    this.intervalTimer = false;
    this.parentElement.addEventListener('mouseenter', this.mouseEnter.bind(this));
    this.scrollEvent();
    window.addEventListener("scroll", this.scrollEvent.bind(this), false);
    window.addEventListener("resize", this.scrollEvent.bind(this), false);
  }
  scrollEvent(){
    if(this.getBoundingClientRect().top > window.innerHeight || this.classList.contains('inited')) return false;
    this.classList.add('inited');
    this.init();
  }
  init(){
    this.percentStart = 0;
    this.progressDelay = this.full_time/this.percent;
    this.classList.add('progress--animated');
    this.intervalTimer = setInterval(this.timerDelay.bind(this), this.progressDelay);
  }
  mouseEnter(){
    if(this.percentStart >= this.percent && window.innerWidth > 992){
      this.classList.remove('progress--animated');
      setTimeout(this.init.bind(this), 10);      
    }
  }
  timerDelay(){
    this.percentStart += 1;
    this.percent_text.innerHTML = this.percentStart;
    if(this.percentStart >= this.percent){
      clearInterval(this.intervalTimer);
    }
  }
}
customElements.define('progress-circle', progressCircle);

class tickerHandler extends HTMLElement {
  constructor() {
    super();
    this.width = 0;
    this.ticker = this.querySelector('.ticker__container');
    Shopify.designMode ? setTimeout(this.resizeHandler.bind(this), 100) : this.resizeHandler();
    window.addEventListener("resize", this.resizeHandler.bind(this), false);
  }
  resizeHandler(){
    if(this.width == window.innerWidth) return;
	this.width = window.innerWidth;
    this.ticker.classList.remove('ticker--animation');
    var boxes = this.querySelectorAll('.ticker--clone');
    if(boxes.length){
      boxes.forEach(e => e.remove());
    }
    var length = window.innerWidth / this.ticker.offsetWidth,
        clone = false;
    length = length==Infinity?5:length;
    for(var i=0; i < length; i++){
      clone = this.ticker.cloneNode(true);
      clone.classList.add('ticker--clone');
      clone.classList.add('ticker--animation');
      this.append(clone);
    }
    this.ticker.classList.add('ticker--animation');
  }
}
customElements.define('ticker-section', tickerHandler);

class showAllFacets extends HTMLElement {
  constructor() {
    super();
    this.parent = this.closest('.facets__display__content');
    this.classToWork = 'show-all-items';
    this.addEventListener('click', this.handler.bind(this), false);
  }
  handler(){
    if (this.parent.classList.contains(this.classToWork)) {
      this.parent.classList.remove(this.classToWork);
    }
    else{
      this.parent.classList.add(this.classToWork);
    }
    window.dispatchEvent(new Event('resize'));
  }
}
customElements.define('show-all-facets', showAllFacets);

class headerMenuTiles extends HTMLElement {
  constructor() {
    super();
    if(!this.querySelectorAll('.submenu-design__simple').length) return;
    
    this.resizeHandler();
    window.addEventListener("resize", this.resizeHandler.bind(this), false);
  }   
  resizeHandler(){
    this.querySelectorAll('.submenu--to-left--js').forEach((item) => {
      item.classList.remove('submenu--to-left--js')
    }); 
    
    var offsetLeft = this.querySelector('nav').offsetLeft;    
    this.querySelectorAll('.submenu-position-js').forEach((item) => {
      item.querySelector('.tiles-menu-item').addEventListener("mouseover", function( event ) {
        var submenu = item.querySelector('.submenu-design__simple'),
            position = offsetLeft+submenu.offsetParent.offsetLeft+submenu.clientWidth*2;
        if(window.innerWidth < position){
        	this.parentNode.classList.add('submenu--to-left--js');
        }
      });
    });
  }
}
customElements.define('header-menu-tiles', headerMenuTiles);

class variantOptionsHandler extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('.product-card__variant-item').forEach((item) => {
      item.addEventListener("mouseenter", this.hoverHandler.bind(item), false);
      item.addEventListener("click", this.hoverHandler.bind(item), false);
    });    
  }   
  hoverHandler(event){    
    if(window.innerWidth < 993 && event.type == "mouseenter"){
      return false;
    }
    if(window.innerWidth < 993){
      event.preventDefault();
    }
    const image_src = this.getAttribute('data-image-src');
    if(image_src == "") return false;
    const product_card = this.closest('.product-card');
    const product_card__image = product_card.querySelector('.product-card__image');
    product_card__image.setAttribute('href', this.getAttribute('href'));
    const product_card__image_tag = product_card__image.querySelectorAll('img');
    if(product_card__image_tag.length > 1){
      product_card__image_tag[1].remove();
    }
    product_card__image_tag[0].setAttribute('src', image_src);
    product_card__image_tag[0].setAttribute('srcset', image_src);
  }
}
customElements.define('product-card__variants', variantOptionsHandler);

class termsCheckboxHandler extends HTMLElement {
  constructor() {
    super();
    this.querySelector('input').addEventListener("change", this.changeHandler.bind(this), false);
  }
  changeHandler(event){
    event.target.checked ? this.classList.add('checked') : this.classList.remove('checked');
  }
}
customElements.define('terms_and_condition-checkbox', termsCheckboxHandler);

class bigSliderHandler extends HTMLElement {
  constructor() {
    super();
	
	this.ctrlLeft = this.querySelector('.ctrl .ctrl__button:first-of-type');
	this.ctrlRight = this.querySelector('.ctrl .ctrl__button:last-of-type');
	this.mouse_position_on_click = 0;
    this.new_slide = false;
    this.slider = false;
    this.change_timer = false;
    this.change_time_delay = 500;
    this.slider_time = this.hasAttribute('data-autoplay') ? Number(this.getAttribute('data-autoplay')) : false;
    this.video_autoplay = this.getAttribute('data-video-autoplay') == "true" ? true : false;

    this.resizeHandler();
    setTimeout(this.resizeHandler.bind(this), 500);
	this.ctrlLeft.addEventListener('click', this.sliderToLeft.bind(this));
	this.ctrlRight.addEventListener('click', this.sliderToRight.bind(this));
	
	this.addEventListener('touchstart', this.touchstartHandler.bind(this));
	this.addEventListener('touchend', this.touchendHandler.bind(this));
	this.addEventListener('mousedown', this.mousedownHandler.bind(this));
	this.addEventListener('click', this.mouseupHandler.bind(this));
    window.addEventListener("resize", this.resizeHandler.bind(this), false);
    
	this.querySelectorAll(".big-slider__dots__item").forEach((item) => {
	  item.addEventListener('click', this.dotsClick.bind(this));
	})

	this.querySelectorAll(".video-ctrl__play").forEach((item) => {
	  item.addEventListener('click', this.videoButtonHandler.bind(this));
	})

    var _this = this;
	this.querySelectorAll("video").forEach((item) => {
      item.addEventListener('play', (event) => {
        var duration = Math.max(this.slider_time,Math.round((Number(event.target.duration) - Number(event.target.currentTime))*1000));
        clearTimeout(_this.slider);
        _this.slider = setTimeout(_this.sliderToRight.bind(_this),duration);
      });
	})

	setTimeout(this.deleteImagesLazy.bind(this),1000);
    this.classList.add('big-slider-initialized');
    this.slider_time && this.startAutoplay();
    this.slider_time && document.addEventListener('scroll', this.documentScrollHandler.bind(this));
    this.scroll_down = true;
	this.video_autoplay && setTimeout(this.checkVideoSlide.bind(this),1000);
    this.deletePlayForExcludedBrowsers();

    if(!this.querySelectorAll('[data-type="youtube"]').length) return;
    var tag = document.createElement('script');
    tag.src = "https://www.youtube.com/iframe_api";
    var firstScriptTag = document.getElementsByTagName('script')[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
  }
  documentScrollHandler(e){
    var window_y = window.scrollY,
        offset_top = this.parentNode.offsetTop,
        object_bottom_position = this.offsetHeight + offset_top;

    if(window_y > object_bottom_position - 100){
      this.scroll_down && clearTimeout(this.slider);
      this.scroll_down = false;
    }
    else{
      !this.scroll_down && this.startAutoplay();
      this.scroll_down = true;
    }
  }  
  startChangeDelay(){
    clearTimeout(this.change_timer);
    this.classList.add("change-current-slide");
    this.change_timer = setTimeout(this.stopChangeDelay.bind(this),this.change_time_delay);
  }
  stopChangeDelay(){
    this.classList.remove("change-current-slide");
  }
  startAutoplay(){
    clearTimeout(this.slider);
    this.slider = setTimeout(this.sliderToRight.bind(this),this.slider_time);
  }
  videoButtonHandler(event){
	event.preventDefault();
	var action = event.target.classList.contains('video-active') ? 'pause' : 'play';
	this.playPauseVideo(event.target,action);
  }
  resizeHandler(){
	var _this = this;
    _this.querySelector('.slideshow-active-in-start') && _this.querySelector('.slideshow-active-in-start').classList.remove('slideshow-active-in-start');
	setTimeout(function(){
      _this.classList.remove('big-slider-initialized');
      var item_height = 0;
      if(window.innerWidth < 993){
        _this.style.height = '';
        _this.querySelectorAll('.slideshow').forEach((item) => {
          var play_button = item.querySelector(".video-ctrl__play");
          if(play_button){
			play_button.style.top = Number(item.querySelector(".image-hover-scaling__image").offsetHeight - play_button.offsetHeight - 10) + "px";
		  }
          if(_this.excludedBrowsers()){
            item_height = Math.max(item_height, item.scrollHeight);
          }
        });
        if(!_this.excludedBrowsers()){
          item_height = _this.querySelector('.slideshow.active').offsetHeight;
        }
        var additional_height = Math.max(_this.ctrlLeft.offsetHeight, _this.querySelector(".big-slider__dots").offsetHeight+8);
        _this.ctrlLeft.style.top = Number(item_height+40)+"px";
        _this.ctrlRight.style.top = Number(item_height+40)+"px";
        item_height += additional_height > 8 ? additional_height+40 : 0;        
      }
      else{
		var item = _this.querySelector('.slideshow.active');
        _this.ctrlLeft.style.top = "";
        _this.ctrlRight.style.top = "";
		item_height = item.offsetHeight;
      }
  	  _this.style.height = Math.round(item_height)+'px';
      _this.classList.add('big-slider-initialized');

      _this.resizePlayer();
	},200);
  }
  deleteImagesLazy(){
	this.querySelectorAll('[loading]').forEach((item) => {
		item.removeAttribute('loading');     
	}); 
  }
  dotsClick(event){
    this.new_slide = true;
    this.startChangeDelay();
    event.target.parentNode.querySelector('.active').classList.remove('active');
    event.target.classList.add("active");
    var index = Number(event.target.getAttribute("data-index"));
    this.querySelector(`.big-slider__items ${this.getItemName()}.active`).classList.remove('active');
    this.querySelectorAll(`.big-slider__items ${this.getItemName()}`)[index].classList.add('active');
	var videoPlayer = this.querySelector('.video-active');
	videoPlayer && videoPlayer.querySelector('.video-active').dispatchEvent(new Event('click'));
    this.slider_time && this.startAutoplay();
	this.videoHandler();
    this.resizeHandler();
  }
  sliderToLeft(){
    this.new_slide = true;
    this.startChangeDelay();
    if (!this.querySelector(`.big-slider__items ${this.getItemName()}.active`).previousSibling) {
      this.querySelectorAll(".for-buttons--js").forEach((item) => {
        item.querySelector(`${this.getItemName()}.active`).classList.remove('active');
        item.querySelectorAll(`${this.getItemName()}`)[item.querySelectorAll(`${this.getItemName()}`).length - 1].classList.add('active');
      })
    } else {
      this.querySelectorAll(".for-buttons--js").forEach((item) => {
        var slider_child = item.querySelector(`${this.getItemName()}.active`);
        slider_child.classList.remove('active');
        slider_child.previousSibling.classList.add('active');
      })
    }
	var videoPlayer = this.querySelector('.video-active');
	videoPlayer && videoPlayer.querySelector('.video-active').dispatchEvent(new Event('click'));
    this.slider_time && this.startAutoplay();
    this.videoHandler();
    this.resizeHandler();
  }
  sliderToRight(){
    this.new_slide = true;
    this.startChangeDelay();
	var active_slide = false;
    if (!this.querySelector(`.big-slider__items ${this.getItemName()}.active`).nextSibling) {
      this.querySelectorAll(".for-buttons--js").forEach((item) => {
        item.querySelector(`${this.getItemName()}.active`).classList.remove('active');
        item.querySelectorAll('.for-buttons__item--js')[0].classList.add('active');
      })
    } else {
      this.querySelectorAll(".for-buttons--js").forEach((item) => {
        var slider_child = item.querySelector(`${this.getItemName()}.active`);
        slider_child.classList.remove('active');
        slider_child.nextSibling.classList.add('active');
      })
    }
	var videoPlayer = this.querySelector('.video-active');
	videoPlayer && videoPlayer.querySelector('.video-active').dispatchEvent(new Event('click'));
    this.slider_time && this.startAutoplay();
	this.videoHandler();
    this.resizeHandler();
  }
  videoHandler(){
    this.deletePlayForExcludedBrowsers();
    this.video_autoplay && this.checkVideoSlide();
  }
  checkVideoSlide(active_slide){
	var video_button = this.querySelector('.slideshow.active .video-ctrl__play');
	if(!video_button) return;
	video_button.dispatchEvent(new Event('click'));
  }
  deletePlayForExcludedBrowsers(){
    if(!this.excludedBrowsers()) return;
	var video_button = this.querySelector('.slideshow.active .video-ctrl__play');
    video_button.remove();
  }
  touchstartHandler(event){
	this.mouse_position_on_click = event.touches[0].clientX;
  }
  touchendHandler(event){
    var delta = 50;
    if(this.mouse_position_on_click > event.changedTouches[0].clientX+delta){
      this.sliderToRight();
    }
    else if(this.mouse_position_on_click < event.changedTouches[0].clientX-delta){
      this.sliderToLeft();
    }
  }
  mousedownHandler(event){
	this.mouse_position_on_click = event.screenX;
  }
  mouseupHandler(event){
    var delta = 50;
    if(this.mouse_position_on_click > event.screenX+delta){
	  event.preventDefault();
      this.sliderToRight();
    }
    else if(this.mouse_position_on_click < event.screenX-delta){
	  event.preventDefault();
      this.sliderToLeft();
    }
  }
  getItemName(){
	  return '.for-buttons__item--js';
  }

  resizePlayer(ratio) {
    var media_player = this.querySelectorAll('.slide-media');
    if (!media_player[0]) return;
    var ratio = ratio || 16/9,
        playerWidth,
        playerHeight;
    
    media_player.forEach((item) => {
      var win = item.closest('.slideshow').querySelector('.image-hover-scaling__image'),
          width = win.offsetWidth,
          height = win.offsetHeight,
          slide_video_html = item.parentNode,
          current = item;
      slide_video_html.style.height = height + 'px';
      if (width / ratio < height) {
        playerWidth = Math.ceil(height * ratio);
        current.style.width = playerWidth + 'px';
        current.style.height = height + 'px';
        current.style.left = Math.round(Number((width - playerWidth) / 2)) + 'px';
        current.style.top = 0;
      } else {
        playerHeight = Math.ceil(width / ratio);
        current.style.width = width + 'px';
        current.style.height = playerHeight + 'px';
        current.style.left = 0;
        current.style.top = Math.round(Number((height - playerHeight) / 2)) + 'px';
      }
    });
  }
  
  postMessageToPlayer(player, command){
    if (player == null || command == null) return;
    player.contentWindow.postMessage(JSON.stringify(command), "*");
  }

  playPauseVideo(target, control){   
	var item, slideType, player, video;
	item = target.closest(".slideshow").querySelector(".video-container");
	slideType = item.getAttribute('data-type');
	player = item.querySelector("iframe");
    if (slideType === "youtube") {
      if(!player){
        var id = item.querySelector("[id]").getAttribute("id"),
            vid_id = id.split('_____').shift(),
            _this = this,
            mute = item.getAttribute("data-mute") == "true" ? 1 : 0;
        player = new YT.Player(id, {
          height: '520',
          width: '980',
          videoId: vid_id,
          playerVars: {
            'playsinline': 1,
            'mute': mute,
			'controls':0,
			'fs':0,
			'iv_load_policy':3,
			'rel':0,
			'showinfo':0,
			'modestbranding':1,
			'loop':1,
            'autoplay':1
          },
          events: {
            'onStateChange': this.onStateChange.bind(this, item)
          }
        });
        player = item.querySelector("iframe");
        setTimeout(function(){
          _this.postMessageToPlayer(player, {
            "event": "command",
            "func": "playVideo"
          });
        }, 0);
        return;
      }      
      switch (control) {
        case "play":
          if(this.new_slide){
            this.postMessageToPlayer(player, {
              "event": "command",
              "func": "stopVideo"
            });
            this.new_slide = false;
          }
          this.postMessageToPlayer(player, {
            "event": "command",
            "func": "playVideo"
          });
          break;
        case "pause":
          this.postMessageToPlayer(player, {
            "event": "command",
            "func": "pauseVideo"
          });
          break;
      }
    } else if (slideType === "video") {
      video = item.querySelector("video");
      if (video != null) {
        if (control === "play"){
          if(this.new_slide){
            video.currentTime = 0;
            this.new_slide = false;
          }
          playVideo(target, video, this.excludedBrowsers());
        }
        else{
          video.pause();
          playButtonPause(target, video, this.excludedBrowsers());
        }
      }
    }
  }
  onStateChange(item, event) {
    var _parent = item.closest('.slideshow');
    if(event.data != 1){
      playButtonPause(_parent.querySelector('.video-ctrl__play'));
      return;
    }
    playButton(_parent.querySelector('.video-ctrl__play'));
    var duration = Math.round((event.target.getDuration()-event.target.getCurrentTime())*1000);
    clearTimeout(this.slider);
    this.slider = setTimeout(this.sliderToRight.bind(this),duration);
  }
  excludedBrowsers(){
    return navigator.userAgent.indexOf("MiuiBrowser") > -1;
  }
}
customElements.define('big-slider', bigSliderHandler);

async function playVideo(target, videoElem, excluded_browsers) {
  if(excluded_browsers) return false;
  try {
    await videoElem.play();
    playButton(target);
  } catch (err) {
    playButtonPause(target);
  }
}
function playButton(target){
  target.classList.add("video-active");
  target.closest('.slideshow').classList.add("video-active");
  target.closest('.slideshow').classList.add("video-loaded");
}
function playButtonPause(target, videoElem, excluded_browsers){
  target.classList.remove("video-active");
  target.closest('.slideshow').classList.remove("video-active");
}

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then(response => response.text())
        .then(text => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          if (!this.querySelector('.product-card-complementary') && this.classList.contains('complementary-products')) {
            this.closest('.chm-toggle') && this.closest('.chm-toggle').remove();
            this.remove();
          }

          if (html.querySelector('.grid__item')) {
            this.classList.add('product-recommendations--loaded');
          }
          initImageScale();
        })
        .catch(e => {
          console.error(e);
        });
    }

    new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 400px 0px'}).observe(this);
  }
}
customElements.define('product-recommendations', ProductRecommendations);

class drawerInner extends HTMLElement {
  constructor() {
    super();
    window.addEventListener("resize", this.resizeHandler.bind(this), false);
    this.resizeHandler();
  }
  resizeHandler(){
    this.scrollTop = 0;
  }
}
customElements.define('drawer-inner', drawerInner);

class AnnouncementBar extends HTMLElement {
  constructor() {
    super();
    this.delay = Number(this.getAttribute('data-delay'))*1000;
    this.start();
    this.addEventListener('mouseover', this.over.bind(this));
    this.addEventListener('mouseleave', this.leave.bind(this));
  }
  over(){
    this.stop();
  }
  leave(){
    this.start();
  }  
  start(){
      this.intervalID = setInterval(this.startSlider.bind(this), this.delay);
  }
  stop(){
      clearInterval(this.intervalID);
  }
  startSlider(){
    var item = this.querySelector('.active'),
        parent = item.parentElement,
        length = this.querySelectorAll('.announcement-bar-js').length-1,
        index = Number(Array.prototype.indexOf.call(parent.children, item)),
        el = false;
    item.classList.remove('active');
    item.classList.remove('active-show');
    if(index >= length){
      el = this.querySelectorAll('.announcement-bar-js')[0];
    }
    else{
      el = item.nextElementSibling;
      
    }
    el.classList.add('active');
    setTimeout(function(){el.classList.add('active-show');}, 50)
  }
}
customElements.define('announcement-bar', AnnouncementBar);

class CollectionsTabs extends HTMLElement {
  constructor() {
    super();
    this.settings = this.getAttribute("data-settings");
    this.featured_col_tabs = this.parentNode.querySelector('featured-collection-tabs-content');
    this.tabs__indicator = this.querySelector('.tabs__indicator');
    this.querySelectorAll('.featured-collection-tabs__item-main').forEach(
      (button) => {
        button.addEventListener('click', this.onTabClick.bind(this));
        button.addEventListener('keydown', (event) => {
          event.code.toUpperCase() == "ENTER"&&event.currentTarget.dispatchEvent(new Event('click'));
        });
      }
    );
    this.querySelectorAll('.featured-collection-tabs__item-secondary').forEach(
      (button) => {
        button.addEventListener('click', this.onTabSecondaryClick.bind(this));
        button.addEventListener('keydown', (event) => {
          event.code.toUpperCase() == "ENTER"&&event.currentTarget.dispatchEvent(new Event('click'));
        });
      }
    );

    var active_item = this.querySelector('.featured-collection-tabs__container-secondary:not(.hide)');
    active_item && active_item.querySelector('.animation-underline--active').dispatchEvent(new Event('click'));

    document.addEventListener("DOMContentLoaded", this.initIndicatorLineStart.bind(this));
    Shopify.designMode&&setTimeout(this.initIndicatorLineStart.bind(this), 200);
  }
  initIndicatorLineStart(){
    this.initIndicatorLine(this.querySelectorAll('.featured-collection-tabs__item-main')[0]);
    document.addEventListener("visibilitychange", () => { 
      this.initIndicatorLine(this.querySelector('.featured-collection-tabs__item-main.animation-underline--active'));
    });
    window.addEventListener("resize", () => { 
      this.initIndicatorLine(this.querySelector('.featured-collection-tabs__item-main.animation-underline--active'));
    });
  }
  onTabClick(e){
    e.preventDefault();
    var current_target = e.currentTarget;
    current_target.parentNode.querySelector(".animation-underline--active").classList.remove("animation-underline--active");
    current_target.classList.add("animation-underline--active");

    this.initIndicatorLine(current_target);
    
    var data_index = current_target.getAttribute('data-index');
    this.querySelector(".featured-collection-tabs__container-secondary:not(.hide)") && this.querySelector(".featured-collection-tabs__container-secondary:not(.hide)").classList.add('hide');
    if(this.querySelector('[data-items-index="'+data_index+'"]')){
      this.querySelector('[data-items-index="'+data_index+'"]').classList.remove('hide');
      this.querySelector('[data-items-index="'+data_index+'"] .animation-underline--active').dispatchEvent(new Event('click'));
    }
  }
  initIndicatorLine(current_target){
    if(!current_target) return;
    var _x = current_target.offsetLeft;
    var _y = Number(current_target.offsetTop)+Number(current_target.getBoundingClientRect().height);
    var _w = Number(current_target.offsetWidth);
    this.tabs__indicator.style.top = _y + 'px';
    this.tabs__indicator.style.left = _x + 'px';
    this.tabs__indicator.style.width = _w + 'px';
  }
  onTabSecondaryClick(e){
    e.preventDefault();
    e.currentTarget.parentNode.querySelector(".animation-underline--active").classList.remove("animation-underline--active");
    e.currentTarget.classList.add("animation-underline--active");

    var collection = e.currentTarget.getAttribute('data-handle'),
        placeholder = e.currentTarget.getAttribute('data-placeholder');
    var _this = this;
    if(this.featured_col_tabs.querySelector('[data-handle-loaded="'+collection+'"]')){
      if(this.featured_col_tabs.querySelector('.active')){
        window.dispatchEvent(new Event('resize', { bubbles: true }));
        this.featured_col_tabs.querySelector('.active').classList.add('tab__smooth_hide');
        setTimeout(function(){
          _this.featured_col_tabs.querySelector('.active').classList.remove('tab__smooth_hide');
          _this.featured_col_tabs.querySelector('.active').classList.remove('active');
          _this.featured_col_tabs.querySelector('[data-handle-loaded="'+collection+'"]').classList.add('active');
          _this.featured_col_tabs.querySelector('[data-handle-loaded="'+collection+'"]').classList.add('tab__smooth_hide');
          setTimeout(function(){
            _this.featured_col_tabs.querySelector('[data-handle-loaded="'+collection+'"]').classList.add('tab__smooth_show');
            setTimeout(function(){
              _this.featured_col_tabs.querySelector('[data-handle-loaded="'+collection+'"]').classList.remove('tab__smooth_hide');
              _this.featured_col_tabs.querySelector('[data-handle-loaded="'+collection+'"]').classList.remove('tab__smooth_show');
              window.dispatchEvent(new Event('resize', { bubbles: true }));
              initImageScale();
            }, 300);
          }, 10);
        }, 250);
      }
      else{
        this.featured_col_tabs.querySelector('[data-handle-loaded="'+collection+'"]').classList.add('active');
      }
    }
    else{
      this.getProducts(collection, placeholder);
    }
  }
  getProducts(currentproducts, placeholder){
    var _this = this;
    this.featured_col_tabs.querySelector('.active')&&this.featured_col_tabs.querySelector('.active').classList.add('tab__smooth_hide');
    fetch(`${window.routes.collections_url}/${currentproducts}?view=ajax_tabs&sort_by=${_this.settings}___${placeholder}`)
      .then((response) => response.text())
      .then((responseText) => {
        if(this.featured_col_tabs.querySelector('.active')){
          this.featured_col_tabs.querySelector('.active').classList.remove('tab__smooth_hide');
          this.featured_col_tabs.querySelector('.active').classList.remove('active');
        }
        var content = document.createElement('div');
        content.classList.add('active');
        content.classList.add('tab__smooth_hide');
        content.classList.add('featured-collection-tab-products');
        content.setAttribute('data-handle-loaded', currentproducts);
        content.innerHTML = responseText;
        this.featured_col_tabs.appendChild(content);
        setTimeout(function(){
          content.classList.add('tab__smooth_show');
          setTimeout(function(){
            content.classList.remove('tab__smooth_hide');
            content.classList.remove('tab__smooth_show');
            initImageScale();
          }, 300);
        }, 10);
      });
  }
}
customElements.define('featured-collection-tabs', CollectionsTabs);

document.addEventListener("DOMContentLoaded", (event) => {
  window.addEventListener("resize", initImageScale);
  setTimeout(initImageScale,200);
});
function initImageScale(){
  const SCALE_NUM = 20;
  document.querySelectorAll('.image-hover-scaling__image').forEach((item) => {
    var _scale = 1 + (item.offsetWidth > item.offsetHeight ? SCALE_NUM/item.offsetWidth : SCALE_NUM/item.offsetHeight);
    !item.closest('.image-hover-scaling-internal') && item.style.setProperty('--scale-image', _scale);
    if(item.closest('.image-banner')){
      !item.closest('.page-fullwidth') && !item.closest('.image-banner__internal-hover') ? item.style.setProperty('--scale-image', _scale) : item.style.removeProperty('--scale-image');
    }
    if(item.parentNode.querySelector(".collection-list-type1-pad")){
      item.parentNode.querySelector(".collection-list-type1-pad").style.setProperty('--zoom_scale', _scale);
    }
  });
}

const isIOS = [
  'iPad Simulator',
  'iPhone Simulator',
  'iPod Simulator',
  'iPad',
  'iPhone',
  'iPod',
].indexOf(navigator.platform) !== -1;
if(isIOS){
  document.querySelectorAll('.color__swatch--image [loading]').forEach((item) => {
    item.removeAttribute('loading');
  });
}

// Ally Fixes

// Fix for AF-6
function fixHeadings() {
  const headings = [
    { elements: document.querySelectorAll('h4.icon-banners__heading'), role: 'heading', level: 3 },
    { elements: document.querySelectorAll('.footer__heading'), role: 'heading', level: 2 },
    { elements: document.querySelectorAll('.chm-toggle__button h4'), role: 'heading', level: 3 },
    { elements: document.querySelectorAll('.blog-posts__heading'), role: 'heading', level: 3},
    { elements: document.querySelectorAll('#collection-list-type1-template--18977245429948__a9e388e3-8d1f-42ef-808d-7ecb65fbc331 > div > div.grid.justify-content-center.heading--mb > div > h2'), role: 'heading', level: 1},
    { elements: document.querySelectorAll('#text-template--18977245823164__5c731a07-9ea9-4461-a07e-2f3c9b74ec26 > div > div > div > h2'), role: 'heading', level: 1},
    { elements: document.querySelectorAll('.text-columns-img__heading'), role: 'heading', level: 3},
    { elements: document.querySelectorAll('.instant-brand-header'), role: 'heading', level: 2},
  ];
  headings.forEach(({ elements, role, level }) => {
    elements.forEach(heading => {
      if (heading.getAttribute('role') !== role || heading.getAttribute('aria-level') !== String(level)) {
        heading.setAttribute('role', role);
        heading.setAttribute('aria-level', level);
      }
    });
  });
}

// Fix for AF-49
function observeAndFocusFirstErrorField() {
  if (!window.location.pathname.includes('account/register')) return;
  const focusFirstErrorField = () => {
    const invalidFields = document.querySelectorAll('[aria-invalid="true"]');
    if (invalidFields.length > 0) {
      invalidFields[0].focus();
    }
  };
  const observer = new MutationObserver(focusFirstErrorField);
  const config = { childList: true, subtree: true, attributes: true };
  observer.observe(document.body, config);
  focusFirstErrorField();
}

// Fix for AF-11
function addRoleAndAriaLevel() {
  const element = document.querySelector('#block-slide_dfaTTM > div');
  if (element) {
    element.setAttribute('role', 'heading');
    element.setAttribute('aria-level', '2'); 
  }
}

// Fix For AF-9 AF-10 and AF-45 
function getVisualZoomPercent() {
  const zoom = (window.outerWidth / window.innerWidth) * 100;
  return Math.round(zoom);
}

function trackVisualZoom(callback) {
  let lastZoom = getVisualZoomPercent();
  function checkZoom() {
    const currentZoom = getVisualZoomPercent();
    if (currentZoom !== lastZoom) {
      lastZoom = currentZoom;
      callback(currentZoom);
    }
    requestAnimationFrame(checkZoom);
  }
  requestAnimationFrame(checkZoom);
  window.addEventListener("resize", () => {
    const currentZoom = getVisualZoomPercent();
    if (currentZoom !== lastZoom) {
      lastZoom = currentZoom;
      callback(currentZoom);
    }
  });
  callback(lastZoom);
}

function addZoomedClasses() {
  trackVisualZoom((zoomPercent) => {
    const carousel = document.querySelector('#slideshow-template--18977245102268__slideshow_LAih8x > div > div > div > big-slider > div.big-slider__dots.for-buttons--js.unstyle-ul.big-slider__dots-center.mobile__navigation__hide');
    if (zoomPercent < 150) {
      carousel.classList.add('mobile__navigation__hide');
    } else {
      carousel.classList.remove('mobile__navigation__hide');
    }
  });
}

function observeElementAndAddZoom() {
  const targetElementId = 'slideshow-template--18977245102268__slideshow_LAih8x';
  const existingElement = document.getElementById(targetElementId);
  if (existingElement) {
    addZoomedClasses();
    return;
  }
  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
        const targetElement = document.getElementById(targetElementId);
        if (targetElement) {
          addZoomedClasses();
          observer.disconnect(); 
          break;
        }
        for (const node of mutation.addedNodes) {
          if (node.nodeType === 1) {
            if (node.id === targetElementId || node.querySelector(`#${targetElementId}`)) {
              addZoomedClasses();
              observer.disconnect();
              return;
            }
          }
        }
      }
    }
  });
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
  const timeout = setTimeout(() => {
    observer.disconnect();
  }, 30000);
  return () => {
    observer.disconnect();
    clearTimeout(timeout);
  };
}

function addHoverStyles(shadowRoot) {
  if (shadowRoot.querySelector('style#hoverStyles')) return;
  const style = document.createElement('style');
  style.id = 'hoverStyles';
  style.textContent = `
    a#ae-menu-4 {
      transition: background-color 0.3s, color 0.3s, border-radius 0.3s; /* Smooth transition */
    }
    .menu #menuItems .inner-menu a:focus, .val:focus{
      outline: 2px solid black !important;
      outline-offset: 1px !important;
    }
    #profile_edit > div.c-bx.no-bg.nsh > div > form > div:nth-child(4) > div > select:focus,
    #profile_edit > div.c-bx.no-bg.nsh > div > form > div:nth-child(4) > div > select:focus-visible{
      border:2px solid black;
    }
    form .btn-secondary:focus{
      outline:2px solid black;
      outline-offset:2px;
    }
    .carousel a:focus{
      border:2px solid black;
      outline:none;
    }
    a{
      color:black;
    }
    .o-i:hover .i-tl,
    .o-i:focus-within .i-tl,
    .item:focus-within .i-tl{
      opacity: 1 !important;
      visibility: visible;
    }
    .content .c-inr .c-bx.order .order-body .order-items 
    .o-i:focus-within a.i-in:not(.no-action) .i-bg{
      opacity: 0.7;
    }

    .content .c-inr .c-bx.order .order-body .order-items 
    .o-i:focus-within a.i-in:not(.no-action) .i-tl{
      opacity: 1;
      transform: translateY(0);
    }
    #recently-viewed .cr-c .carousel .item:focus-within .i-bg,
    #cart-saved .cr-c .carousel .item:focus-within .i-bg {
      opacity: 0.7;
    }

    #recently-viewed .cr-c .carousel .item:focus-within .i-tl,
    #recently-viewed .cr-c .carousel .item:focus-within .i-ac,
    #cart-saved .cr-c .carousel .item:focus-within .i-tl,
    #cart-saved .cr-c .carousel .item:focus-within .i-ac {
      opacity: 1;
      transform: translateY(0);
    }
    div[role="listitem"]{
      width:100%;
    }
    .ar{
      width:20px !important;
    }
    .b-gr .btn-primary{
      background-color:#cb474b !important;
    } 
    .search-input::-webkit-input-placeholder { color: #737373 !important; }
    #profile_edit .input-group input:not(:placeholder-shown) + label, #profile_edit .input-group.chHasPhone label{
      color:#747474 !important;
    }
    #
  `;
  const outerContainer = document.querySelector('#MainContent > accounts-hub');
  if (outerContainer && outerContainer.shadowRoot) {
    const shadowDom = outerContainer.shadowRoot;
    shadowDom.appendChild(style);
  }
}

function fixReflowForAccountsPage() {
  const selectors = [
    'a.view-orders',
    '#profile-card a.val',
    'a.view-order',
    'a.i-in',
    '#cart-saved a',
    '#recently-viewed a'
  ];

  function disableAnchors(shadowDom) {
    selectors.forEach(sel => {
      const anchors = shadowDom.querySelectorAll(sel);
      anchors.forEach(anchor => {
        anchor.href = 'javascript:void(0)';
      });
    });
  }

  function addAriaLiveToOrderCount(shadowDom) {
    if (!shadowDom) return;
    const target = shadowDom.querySelector(
      "#ae-holder > div > div.content > div > div:nth-child(3) > div > div.order-count"
    );
    if (target) {
      if (!target.hasAttribute("aria-live")) {
        target.setAttribute("aria-live", "polite");
      }
      if (!shadowDom.querySelector("#filter-by-label")) {
        const select = shadowDom.querySelector('#ae-holder > div > div.content > div > div:nth-child(3) > div > select');
        const label = document.createElement("label");
        label.id = "filter-by-label";
        label.textContent = "Filter By :";
        label.style.marginLeft = "57%";
        label.setAttribute('for',"filter-by-select");
        select.setAttribute('id','filter-by-select');
        target.insertAdjacentElement("afterend", label);
      }
    }
  }

  function updateMenu(shadowDom) {
    const menuDiv = shadowDom.querySelector('div.menu');
    if (!menuDiv) return;
    const menuItemsDiv = menuDiv.querySelector('div#menuItems > div.inner-menu');
    if (!menuItemsDiv) return;

    if (!menuItemsDiv.querySelector('a#ae-menu-4')) {
      const newElement = document.createElement('a');
      newElement.setAttribute('id', 'ae-menu-4');
      newElement.setAttribute('href', 'https://anaheimfeed.com/a/customerhub#account:a:logout');
      newElement.setAttribute('target', '_self');
      const span = document.createElement('span');
      span.textContent = 'Logout';
      newElement.appendChild(span);
      menuItemsDiv.appendChild(newElement);
      addHoverStyles(shadowDom);
    }
  }

  function observeNotifications(shadowDom) {
    if (!shadowDom) return;
    const notifObserver = new MutationObserver(mutations => {
      for (const mutation of mutations) {
        if (!mutation.addedNodes.length) continue;
        for (const node of mutation.addedNodes) {
          if (node.nodeType !== Node.ELEMENT_NODE) continue;
          if (node.classList.contains("success")) {
            makeAnnounceable(node);
          }
          const innerNotifs = node.querySelectorAll?.(".success");
          if (innerNotifs && innerNotifs.length) {
            innerNotifs.forEach(makeAnnounceable);
          }
        }
      }
    });
    notifObserver.observe(shadowDom, {
      childList: true,
      subtree: true
    });
    shadowDom.querySelectorAll(".success").forEach(makeAnnounceable);

    function makeAnnounceable(node) {
      if (!node.hasAttribute("aria-live")) {
        node.setAttribute("role", "status");
        node.setAttribute("aria-live", "polite");
        const msg = node.textContent.trim();
        if (msg) {
          const originalHTML = node.innerHTML;
          node.innerHTML = "";
          setTimeout(() => {
            node.innerHTML = originalHTML;
          }, 50);
        }
      }
    }
  }

  function labelCancelledOrders(shadowDom) {
    if (!shadowDom) return;
    const cancelledOrders = shadowDom.querySelectorAll('.is-cancelled');
    cancelledOrders.forEach((order, index) => {
      const itemTitle = order.querySelector('.order-items span.i-tl');
      const viewOrderLink = order.querySelector('a.view-order');
      if (itemTitle && viewOrderLink) {
        const spanId = `cancelled-order-title-${index + 1}`;
        const anchorId = `cancelled-order-link-${index + 1}`;
        itemTitle.id = spanId;
        viewOrderLink.id = anchorId;
        viewOrderLink.setAttribute('aria-labelledby', `${anchorId} ${spanId}`);
      }
    });
  }

  function applyAll(shadowDom) {
    addHoverStyles(shadowDom);
    disableAnchors(shadowDom);
    updateMenu(shadowDom);
    addAriaLiveToOrderCount(shadowDom);
    observeNotifications(shadowDom);
    labelCancelledOrders(shadowDom);
  }

  function observeShadowDom(shadowDom) {
    const shadowObserver = new MutationObserver(() => {
      applyAll(shadowDom);
    });
    shadowObserver.observe(shadowDom, { childList: true, subtree: true });
  }

  const observer = new MutationObserver(() => {
    const outerContainer = document.querySelector('#MainContent > accounts-hub');
    if (outerContainer && outerContainer.shadowRoot) {
      applyAll(outerContainer.shadowRoot);
      observeShadowDom(outerContainer.shadowRoot);
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });

  window.addEventListener("hashchange", () => {
    const outerContainer = document.querySelector('#MainContent > accounts-hub');
    if (outerContainer && outerContainer.shadowRoot) {
      applyAll(outerContainer.shadowRoot);
      observeShadowDom(outerContainer.shadowRoot);
    }
  });

  const outerContainer = document.querySelector('#MainContent > accounts-hub');
  if (outerContainer && outerContainer.shadowRoot) {
    applyAll(outerContainer.shadowRoot);
    observeShadowDom(outerContainer.shadowRoot);
  }
}


trackVisualZoom((zoomPercent) => {
  if (zoomPercent > 125) {
    fixReflowForAccountsPage();
    observeElementAndAddZoom();
  }
});

// Fix for AF-3
function makeModalAccessible(triggerSelector = 'td.as-product-line-amount svg') {
  let triggeringElement = null;
  let currentModal = null;
  let modalCheckTimer = null;

  const ENHANCED_FLAG = 'data-ma-enhanced';
  const listenersMap = new WeakMap();

  function enhanceTrigger(el) {
    if (!el || el.nodeType !== 1) return;
    if (el.hasAttribute(ENHANCED_FLAG)) return;

    el.setAttribute(ENHANCED_FLAG, '1');
    el.setAttribute('tabindex', '0');
    el.setAttribute('role', 'button');
    el.setAttribute('aria-haspopup', 'dialog');
    el.removeAttribute('aria-hidden');
    el.setAttribute('data-modal-trigger', 'true');

    function onClick() {
      triggeringElement = el;
      setTimeout(checkForOpenModals, 30);
    }

    function onKeydown(e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        onClick();
        if (typeof el.click === 'function') el.click();
        else el.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true }));
      }
    }

    el.addEventListener('click', onClick, true);
    el.addEventListener('keydown', onKeydown, true);
    listenersMap.set(el, { onClick, onKeydown });
  }

  function setupTriggers() {
    let nodes;
    try {
      nodes = document.querySelectorAll(triggerSelector);
    } catch {
      nodes = document.querySelectorAll('td.as-product-line-amount svg');
    }
    nodes.forEach(enhanceTrigger);
  }

  setupTriggers();
  const triggersObserver = new MutationObserver(() => setTimeout(setupTriggers, 25));
  triggersObserver.observe(document.body, { childList: true, subtree: true });

  function findDialog(root = document) {
    return root.querySelector('[role="dialog"][aria-modal="true"]') ||
           root.querySelector('[role="dialog"]') ||
           root.querySelector('[id^="headlessui-dialog-"]') ||
           root.querySelector('[data-headlessui-dialog]');
  }

  function focusFirstInteractive(modal) {
    const focusable = modal.querySelector(
      'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
    );
    if (focusable) focusable.focus({ preventScroll: false });
    else modal.focus({ preventScroll: false });
  }

  function checkForOpenModals() {
    const portal = document.querySelector('#headlessui-portal-root') || document.body;
    const dialog = findDialog(portal);
    if (dialog) {
      const style = window.getComputedStyle(dialog);
      const hidden = style.display === 'none' || style.visibility === 'hidden' || dialog.getAttribute('aria-hidden') === 'true';
      if (!hidden) {
        if (currentModal !== dialog) onModalOpen(dialog);
      } else if (currentModal) {
        onModalClose();
      }
    } else if (currentModal) {
      onModalClose();
    }
  }

  function onModalOpen(dialog) {
    currentModal = dialog;
    if (!dialog.hasAttribute('tabindex')) dialog.setAttribute('tabindex', '-1');
    focusFirstInteractive(dialog);
    if (modalCheckTimer) clearInterval(modalCheckTimer);
    modalCheckTimer = setInterval(() => {
      if (!document.contains(dialog)) {
        onModalClose();
        return;
      }
      const s = window.getComputedStyle(dialog);
      if (dialog.getAttribute('aria-hidden') === 'true' || s.display === 'none' || s.visibility === 'hidden') {
        onModalClose();
      }
    }, 120);
  }

  function onModalClose() {
    if (modalCheckTimer) { clearInterval(modalCheckTimer); modalCheckTimer = null; }
    if (!currentModal) return;
    setTimeout(() => {
      if (triggeringElement && document.contains(triggeringElement)) {
        triggeringElement.focus({ preventScroll: false });
      }
      currentModal = null;
      triggeringElement = null;
    }, 10);
  }

  const bodyObserver = new MutationObserver(() => setTimeout(checkForOpenModals, 10));
  bodyObserver.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['aria-hidden', 'style'] });

  window.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && currentModal) setTimeout(checkForOpenModals, 30);
  });

  setTimeout(checkForOpenModals, 50);

  const headingConfigs = [
    { selector: '.as-subscription-detail-header_title', role: 'heading', level: 2 },
    { selector: '.as-product-details_title', role: 'heading', level: 3 },
    { selector: '.as-card_title', role: 'heading', level: 3 },
  ];

  function applyHeadingRoles(root = document) {
    headingConfigs.forEach(({ selector, role, level }) => {
      root.querySelectorAll(selector).forEach(el => {
        if (!el.hasAttribute('role')) {
          el.setAttribute('role', role);
          el.setAttribute('aria-level', level);
        }
      });
    });
  }
  applyHeadingRoles(document);
  const headingObserver = new MutationObserver(() => applyHeadingRoles(document));
  headingObserver.observe(document.body, { childList: true, subtree: true });

  function cleanup() {
    triggersObserver.disconnect();
    bodyObserver.disconnect();
    headingObserver.disconnect();
    if (modalCheckTimer) clearInterval(modalCheckTimer);
    document.querySelectorAll(triggerSelector).forEach((el) => {
      const handlers = listenersMap.get(el);
      if (handlers) {
        el.removeEventListener('click', handlers.onClick, true);
        el.removeEventListener('keydown', handlers.onKeydown, true);
        el.removeAttribute(ENHANCED_FLAG);
        listenersMap.delete(el);
      }
    });
  }

  return { cleanup };
}

function observeTooltipElement() {
  function initializeSingleTooltip() {
    const tooltipWrapper = document.querySelector('div.appstle_tooltip_wrapper');
    if (!tooltipWrapper) return;
    const tooltipContent = tooltipWrapper.querySelector('.appstle_tooltip');
    if (!tooltipContent) return;
    const tooltipId = 'appstle-tooltip';
    tooltipContent.setAttribute('id', tooltipId);
    tooltipContent.setAttribute('role', 'tooltip');
    tooltipContent.setAttribute('aria-hidden', 'true');
    tooltipWrapper.setAttribute('tabindex', 0);
    tooltipWrapper.setAttribute('role', 'button');
    tooltipWrapper.setAttribute('aria-describedby', tooltipId);
    tooltipWrapper.setAttribute('aria-expanded', 'false');
    const showTooltip = () => {
      tooltipContent.classList.add('appstle_tooltip_focused');
      tooltipContent.setAttribute('aria-hidden', 'false');
      tooltipWrapper.setAttribute('aria-expanded', 'true');
    };
    const hideTooltip = () => {
      tooltipContent.classList.remove('appstle_tooltip_focused');
      tooltipContent.setAttribute('aria-hidden', 'true');
      tooltipWrapper.setAttribute('aria-expanded', 'false');
    };
    const svgElement = tooltipWrapper.querySelector('svg');
    if (svgElement) {
      svgElement.addEventListener('mouseenter', showTooltip);
      svgElement.addEventListener('mouseleave', hideTooltip);
    }
    tooltipWrapper.addEventListener('keyup', (event) => {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        if (tooltipContent.getAttribute('aria-hidden') === 'false') {
          hideTooltip();
        } else {
          showTooltip();
        }
      }
      if (event.key === 'Escape') {
        hideTooltip();
      }
    });
    tooltipWrapper.addEventListener('click', () => {
      if (tooltipContent.getAttribute('aria-hidden') === 'false') {
        hideTooltip();
      } else {
        showTooltip();
      }
    });
    document.addEventListener('click', (event) => {
      if (!tooltipWrapper.contains(event.target)) {
        hideTooltip();
      }
    });
  }
  const observer = new MutationObserver((mutationsList, observer) => {
    const tooltipWrapper = document.querySelector('div.appstle_tooltip_wrapper');
    if (tooltipWrapper) {
      initializeSingleTooltip();
      observer.disconnect();
    }
  });
  observer.observe(document.body, { childList: true, subtree: true });
}

// Fix for AF-15
function fixIncorrectHeadings(){
  const selectors=["h5","h6","#slider--AbXVyRjlFeWRLV2xHO__lfs_instant_brand_page_brand_slider_4TGXkY > div.owl-stage-outer h5.brand-slider-text"];
  const el2=document.querySelector("#shopify-section-template--18977245724860__main > div > div > div > p:nth-child(6) > strong:nth-child(2)");
  if(el2){
    el2.setAttribute("role","heading");
    el2.setAttribute("aria-level","2")
  }
  selectors.forEach(selector=>{
    document.querySelectorAll(selector).forEach(el=>{
      el.setAttribute("role","none")}
    )}
  )
}

function insertVisuallyHiddenHeading(headingText, targetSelector) {
  const targetElement = document.querySelector(targetSelector);
  if (!targetElement) return;

  let hiddenH1 = targetElement.querySelector("h1.visually-hidden");
  if (!hiddenH1) {
    hiddenH1 = document.createElement("h1");
    hiddenH1.classList.add("visually-hidden");
    targetElement.insertBefore(hiddenH1, targetElement.firstChild);
  }
  hiddenH1.textContent = headingText;
}
// Fix for AF-51 and AF-28

(function initDynamicTitle() {
  const siteName = 'Anaheim Feed & Pet Supply';

  const routePatterns = [
    { pattern: /^\/subscriptions\/\d+\/detail$/, title: 'My Account – Auto Delivery Detail', h1Text: 'Auto Delivery Details for Current Order' },
    { pattern: /^\/subscriptions\/list$/, title: 'My Account – Auto Deliveries', h1Text: 'Your Auto Deliveries Subscriptions' },
    { pattern: /^\/subscriptions$/, title: 'My Account – Auto Deliveries', h1Text: 'Your Auto Deliveries Subscriptions' },
    { pattern: /dashboard$/, title: 'My Account – For You', h1Text: 'Welcome to Your Account Dashboard' },
    { pattern: /orders$/, title: 'My Account – Online Orders', h1Text: 'Your Online Orders History' },
    { pattern: /profile(-edit)?$/, title: 'My Account – Profile', h1Text: 'Edit Your Account Profile and Preferences' }
  ];

  function normalizePath(path) {
    return path.replace(/\/+$/, '');
  }

  function getCurrentPath() {
    const fullPath = window.location.hash
      ? window.location.hash.replace(/^#/, '')
      : window.location.pathname + window.location.search;
    return normalizePath(fullPath.toLowerCase());
  }

  function insertHeading(text, containerSelector) {
    const container = document.querySelector(containerSelector);
    if (!container) return;
    let existing = container.querySelector('h1[data-dynamic-heading]');
    if (!existing) {
      const h1 = document.createElement('h1');
      h1.setAttribute('data-dynamic-heading', 'true');
      h1.className = 'visually-hidden';
      h1.textContent = text;
      container.prepend(h1);
    } else {
      existing.textContent = text;
    }
  }

  function waitForRechargeApp(callback) {
    const target = document.querySelector("#MainContent");
    if (!target) return;
    const observer = new MutationObserver((mutations, obs) => {
      const ready = target.querySelector("accounts-hub.ready");
      if (ready) {
        obs.disconnect();
        callback();
      }
    });
    observer.observe(target, { childList: true, subtree: true });
  }

  function updateTitleAndHeading() {
    const fullPath = getCurrentPath();
    let matchedRoute = null;
    for (let i = 0; i < routePatterns.length; i++) {
      if (routePatterns[i].pattern.test(fullPath)) {
        matchedRoute = routePatterns[i];
        break;
      }
    }

    const pageTitle = matchedRoute ? matchedRoute.title : siteName;
    document.title = pageTitle.includes(siteName) ? pageTitle : `${pageTitle} – ${siteName}`;

    if (matchedRoute?.h1Text) {
      if (/^\/subscriptions(\/list)?$/.test(fullPath)) {
        waitForRechargeApp(() => insertHeading(matchedRoute.h1Text, "#MainContent"));
      } else {
        insertHeading(matchedRoute.h1Text, "#MainContent");
      }
    }
  }

  window.addEventListener("hashchange", updateTitleAndHeading);
  window.addEventListener("popstate", updateTitleAndHeading);

  ["pushState", "replaceState"].forEach(method => {
    const original = history[method];
    history[method] = function () {
      const res = original.apply(this, arguments);
      updateTitleAndHeading();
      return res;
    };
  });

  setTimeout(updateTitleAndHeading, 500);
})();


// (function initDynamicTitle() {
//   const siteName = 'Anaheim Feed & Pet Supply';
//   const routePatterns = [
//     { pattern: /^\/subscriptions\/\d+\/detail$/, title: 'My Account – Auto Delivery Detail' },
//     { pattern: /^\/subscriptions\/list$/, title: 'My Account – Auto Deliveries' },
//     { pattern: /^\/subscriptions$/, title: 'My Account – Auto Deliveries' },
//     { pattern: /dashboard$/, title: 'My Account – For You' },
//     { pattern: /orders$/, title: 'My Account – Online Orders' },
//     { pattern: /profile(-edit)?$/, title: 'My Account – Profile' }
//   ];

//   function getCurrentPath() {
//     const hash = window.location.hash || '';
//     const cleanedHash = hash.replace(/^#/, '').split('?')[0];
//     return cleanedHash ? (cleanedHash.startsWith('/') ? cleanedHash : `/${cleanedHash}`) : (window.location.pathname + (window.location.search || ''));
//   }

//   function collectAnchors() {
//     const anchors = new Set();
//     const host = document.querySelector('#MainContent > accounts-hub');
//     if (host && host.shadowRoot) {
//       const sr = host.shadowRoot;
//       sr.querySelectorAll('#menuItems a, .inner-menu a').forEach(a => anchors.add(a));
//     }
//     document.querySelectorAll('#menuItems a, .inner-menu a, #MainContent a, nav a, .account-nav a').forEach(a => anchors.add(a));
//     return Array.from(anchors);
//   }

//   function updateAriaCurrent() {
//     const anchors = collectAnchors();
//     if (!anchors.length) return;
//     anchors.forEach(a => {
//       if (a.classList.contains('active')) {
//         a.setAttribute('aria-current', 'page');
//       } else {
//         a.removeAttribute('aria-current');
//       }
//     });
//   }

//   function updateTitleAndAria() {
//     const fullPath = getCurrentPath().toLowerCase();
//     let matchedRoute = null;
//     for (let i = 0; i < routePatterns.length; i++) {
//       if (routePatterns[i].pattern.test(fullPath)) {
//         matchedRoute = routePatterns[i];
//         break;
//       }
//     }
//     const pageTitle = matchedRoute ? matchedRoute.title : siteName;
//     document.title = pageTitle.includes(siteName) ? pageTitle : `${pageTitle} – ${siteName}`;
//     updateAriaCurrent();
//   }

//   let shadowObserved = false;
//   function ensureShadowObserver() {
//     const host = document.querySelector('#MainContent > accounts-hub');
//     if (!host || !host.shadowRoot || shadowObserved) return;
//     shadowObserved = true;
//     const so = new MutationObserver(() => updateTitleAndAria());
//     so.observe(host.shadowRoot, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
//   }

//   const docObserver = new MutationObserver(() => {
//     ensureShadowObserver();
//     updateTitleAndAria();
//   });
//   docObserver.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });

//   window.addEventListener('hashchange', updateTitleAndAria);
//   window.addEventListener('popstate', updateTitleAndAria);
//   ['pushState', 'replaceState'].forEach(method => {
//     const original = history[method];
//     history[method] = function () {
//       const res = original.apply(this, arguments);
//       updateTitleAndAria();
//       return res;
//     };
//   });

//   ensureShadowObserver();
//   setTimeout(updateTitleAndAria, 30);
// })();

// Fix for AF-25
function brandsPageListMarkup() {
  const observer = new MutationObserver((mutationsList, observer) => {
    const selectors = ['.instant-brand-az', '.instant-brand-block-brand'];
    let allProcessed = true;
    selectors.forEach(selector => {
      const targetElement = document.querySelector(selector);
      if (targetElement && !targetElement.hasAttribute('data-processed')) {
        targetElement.setAttribute('role', 'list');
        Array.from(targetElement.children).forEach(child => {
          child.setAttribute('role', 'listitem');
        });
        targetElement.setAttribute('data-processed', 'true');
      } else if (!targetElement) {
        allProcessed = false;
      }
    });
    if (allProcessed) {
      observer.disconnect();
    }
  });
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
}

// Fix for AF-18
(function a11yMenubar() {
  document.addEventListener('DOMContentLoaded', () => {
    const menuItems = Array.from(document.querySelectorAll('nav .submenu-container'));
    if (!menuItems.length) return;
    let idCounter = 0;
    const allControls = [];

    function getLabelFromAnchor(anchor) {
      const span = anchor.querySelector('span');
      if (span) {
        for (const node of span.childNodes) {
          if (node.nodeType === Node.TEXT_NODE) {
            const txt = node.textContent.trim();
            if (txt) return txt;
          }
        }
        return span.textContent.trim();
      }
      return anchor.textContent.trim();
    }

    function showSubmenu(button, submenu, anchor) {
      allControls.forEach(c => {
        if (c.button !== button) closeSubmenu(c.button, c.submenu, c.anchor);
      });

      button.setAttribute('aria-expanded', 'true');
      submenu.setAttribute('aria-hidden', 'false');
      submenu.classList.add('submenu--open');
      if (anchor) anchor.setAttribute('aria-expanded', 'true');
    }

    function closeSubmenu(button, submenu, anchor) {
      button.setAttribute('aria-expanded', 'false');
      submenu.setAttribute('aria-hidden', 'true');
      submenu.classList.remove('submenu--open');
      if (anchor) anchor.setAttribute('aria-expanded', 'false');
    }

    function toggleSubmenu(button, submenu, anchor) {
      const expanded = button.getAttribute('aria-expanded') === 'true';
      if (expanded) closeSubmenu(button, submenu, anchor);
      else showSubmenu(button, submenu, anchor);
    }

    menuItems.forEach(li => {
      const anchor = li.querySelector(':scope > a');
      if (!anchor) return;
      const svg = anchor.querySelector('svg');
      const submenu =
        li.querySelector(':scope > .megamenu-container > .submenu-design__megamenu') ||
        li.querySelector(':scope > .megamenu-container') ||
        li.querySelector(':scope > .submenu-design__megamenu') ||
        li.querySelector(':scope > .submenu-design__simple') ||
        li.querySelector('ul');
      if (!svg || !submenu) return;

      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'submenu-svg-toggle';
      button.appendChild(svg);

      const label = getLabelFromAnchor(anchor) || 'submenu';
      button.setAttribute('aria-label', `More about ${label}`);

      if (!submenu.id) {
        idCounter += 1;
        submenu.id = `submenu-${idCounter}`;
      }

      button.setAttribute('aria-controls', submenu.id);
      button.setAttribute('aria-expanded', 'false');
      button.setAttribute('aria-haspopup', 'true');
      submenu.setAttribute('aria-hidden', 'true');

      if (anchor.hasAttribute('aria-expanded')) anchor.removeAttribute('aria-expanded');
      anchor.setAttribute('aria-haspopup', 'true');

      if (anchor.nextSibling) anchor.parentNode.insertBefore(button, anchor.nextSibling);
      else anchor.parentNode.appendChild(button);

      allControls.push({ li, anchor, button, submenu });

      button.addEventListener('click', (ev) => {
        ev.stopPropagation();
        toggleSubmenu(button, submenu, anchor);
      });

      button.addEventListener('keydown', (ev) => {
        const key = ev.key;
        if (key === 'Enter' || key === ' ') {
          ev.preventDefault();
          toggleSubmenu(button, submenu, anchor);
          if (button.getAttribute('aria-expanded') === 'true') {
            const first = submenu.querySelector('a');
            if (first) first.focus();
          }
        } else if (key === 'Escape') {
          ev.preventDefault();
          closeSubmenu(button, submenu, anchor);
          button.focus();
        } else if (key === 'Home' || key === 'End') {
          const idx = allControls.findIndex(c => c.button === button);
          if (idx > -1) {
            ev.preventDefault();
            const targetIdx = key === 'Home' ? 0 : allControls.length - 1;
            const t = allControls[targetIdx];
            if (t && t.button) t.button.focus();
          }
        }
      });

      submenu.addEventListener('keydown', (ev) => {
        const links = Array.from(submenu.querySelectorAll('a'));
        const current = links.indexOf(document.activeElement);
        if (ev.key === 'ArrowDown') {
          ev.preventDefault();
          const next = (current + 1) % links.length;
          links[next].focus();
        } else if (ev.key === 'ArrowUp') {
          ev.preventDefault();
          const prev = (current - 1 + links.length) % links.length;
          links[prev].focus();
        } else if (ev.key === 'Home') {
          ev.preventDefault();
          links[0].focus();
        } else if (ev.key === 'End') {
          ev.preventDefault();
          links[links.length - 1].focus();
        } else if (ev.key === 'Escape') {
          ev.preventDefault();
          closeSubmenu(button, submenu, anchor);
          button.focus();
        } else if (ev.key === 'Tab') {
          setTimeout(() => {
            const active = document.activeElement;
            if (!li.contains(active)) {
              closeSubmenu(button, submenu, anchor);
            }
          }, 0);
        }
      });

      li.addEventListener('focusout', (ev) => {
        const related = ev.relatedTarget;
        if (!related || !li.contains(related)) {
          closeSubmenu(button, submenu, anchor);
        }
      });
    });

    document.addEventListener('click', (ev) => {
      if (!ev.target.closest('nav .submenu-container')) {
        allControls.forEach(c => closeSubmenu(c.button, c.submenu, c.anchor));
      }
    });

    document.__megaMenuControls = {
      closeAll: () => allControls.forEach(c => closeSubmenu(c.button, c.submenu, c.anchor)),
      openIndex: () => allControls.findIndex(c => c.button.getAttribute('aria-expanded') === 'true'),
    };
  });
})();

// Fix for AF-50
function initA11yCarouselControls() {
  const focusableSelector = [
    'a[href]',
    'area[href]',
    'input:not([disabled])',
    'select:not([disabled])',
    'textarea:not([disabled])',
    'button:not([disabled])',
    'iframe',
    'object',
    'embed',
    '[tabindex]',
    '[contenteditable]'
  ].join(',');

  function setSlideInert(slide, inert) {
    if ('inert' in HTMLElement.prototype) {
      slide.inert = inert;
      return;
    }
    const focusables = slide.querySelectorAll(focusableSelector);
    focusables.forEach((el) => {
      if (inert) {
        if (el.hasAttribute('tabindex')) {
          el.dataset.__a11yPrevTabindex = el.getAttribute('tabindex');
        } else {
          el.dataset.__a11yHadNoTabindex = 'true';
        }
        el.setAttribute('tabindex', '-1');
      } else {
        if (typeof el.dataset.__a11yPrevTabindex !== 'undefined') {
          el.setAttribute('tabindex', el.dataset.__a11yPrevTabindex);
          delete el.dataset.__a11yPrevTabindex;
        } else if (el.dataset.__a11yHadNoTabindex !== undefined) {
          el.removeAttribute('tabindex');
          delete el.dataset.__a11yHadNoTabindex;
        }
      }
    });
  }

  function safeClearTimeout(t) {
    try {
      clearTimeout(t);
    } catch (e) {}
  }

  const sliders = document.querySelectorAll('big-slider');
  sliders.forEach((slider, sliderIndex) => {
    const dotsWrapper = slider.querySelector('.big-slider__dots');
    const container = slider.querySelector('.big-slider__items');
    const dots = slider.querySelectorAll('.big-slider__dots__item');
    const slides = slider.querySelectorAll('.slideshow');
    const leftArrow = slider.querySelector('.ctrl__button--left');
    const rightArrow = slider.querySelector('.ctrl__button--right');
    dotsWrapper.setAttribute('role','tablist');
    dotsWrapper.setAttribute('aria-label','Slide navigation');
    container.setAttribute('role','tabpanel');
    container.setAttribute('id','big-slider-Container');
    if (!slides.length || !dots.length) return;
    let originalStartAutoplay = null;
    if (typeof slider.startAutoplay === 'function') {
      originalStartAutoplay = slider.startAutoplay.bind(slider);
      slider.__a11y_originalStartAutoplay = originalStartAutoplay;
    }
    slider.startAutoplay = function patchedStartAutoplay() {
      if (slider.dataset.a11yPaused === 'true') {
        safeClearTimeout(slider.slider);
        return;
      }
      if (typeof slider.__a11y_originalStartAutoplay === 'function') {
        slider.__a11y_originalStartAutoplay();
      }
    };
    if (!('a11yPaused' in slider.dataset)) slider.dataset.a11yPaused = 'false';
    safeClearTimeout(slider.slider);
    const hasAuto = Number(slider.getAttribute('data-autoplay')) > 0;
    if (hasAuto && typeof slider.__a11y_originalStartAutoplay === 'function' && slider.dataset.a11yPaused !== 'true') {
      slider.__a11y_originalStartAutoplay();
    }

    const playPauseBtn = document.createElement('button');
    playPauseBtn.className = 'carousel__pauseplay';
    playPauseBtn.setAttribute('aria-pressed', 'false');
    playPauseBtn.setAttribute('aria-label', 'Pause slideshow');
    playPauseBtn.setAttribute('type', 'button');
    playPauseBtn.innerHTML = '<span aria-hidden="true" class="icon">❚❚</span>';
    slider.parentNode.insertBefore(playPauseBtn, slider);

    function pauseAutoplay() {
      slider.dataset.a11yPaused = 'true';
      safeClearTimeout(slider.slider);
    }
    function resumeAutoplay() {
      slider.dataset.a11yPaused = 'false';
      if (typeof slider.__a11y_originalStartAutoplay === 'function') {
        slider.__a11y_originalStartAutoplay();
      }
    }
    function setPlayPauseUI(paused) {
      playPauseBtn.setAttribute('aria-pressed', paused ? 'true' : 'false');
      playPauseBtn.setAttribute('aria-label', paused ? 'Play slideshow' : 'Pause slideshow');
      playPauseBtn.innerHTML = paused
        ? '<span aria-hidden="true" class="icon">▶</span>'
        : '<span aria-hidden="true" class="icon">❚❚</span>';
    }

    playPauseBtn.addEventListener('click', () => {
      const paused = slider.dataset.a11yPaused === 'true';
      if (paused) {
        resumeAutoplay();
        setPlayPauseUI(false);
      } else {
        pauseAutoplay();
        setPlayPauseUI(true);
      }
    });
    playPauseBtn.addEventListener('keydown', (e) => {
      if (e.key === ' ' || e.key === 'Enter') {
        e.preventDefault();
        playPauseBtn.click();
      }
    });
    if (dotsWrapper) dotsWrapper.setAttribute('role', 'tablist');

    function activateDot(dot, i) {
      pauseAutoplay();
      setPlayPauseUI(true);

      dots.forEach((d, idx) => {
        const isActive = idx === i;
        d.classList.toggle('active', isActive);
        d.setAttribute('tabindex', isActive ? '0' : '-1');
        d.setAttribute('aria-selected', isActive ? 'true' : 'false');

        slides[idx].classList.toggle('active', isActive);
        slides[idx].setAttribute('aria-hidden', isActive ? 'false' : 'true');

        if (isActive) {
          slides[idx].removeAttribute('tabindex');
          setSlideInert(slides[idx], false);
        } else {
          slides[idx].setAttribute('tabindex', '-1');
          setSlideInert(slides[idx], true);
        }
      });
    }

    dots.forEach((dot, i) => {
      dot.setAttribute('role', 'tab');
      if (!dot.hasAttribute('aria-controls')) {
        const panelId = slides[i].id || `a11y-slide-${sliderIndex}-${i}`;
        if (!slides[i].id) slides[i].id = panelId;
        dot.setAttribute('aria-controls', panelId);
      }
      const isActive = slides[i].classList.contains('active');
      dot.setAttribute('tabindex', isActive ? '0' : '-1');
      dot.setAttribute('aria-selected', isActive ? 'true' : 'false');
      slides[i].setAttribute('aria-hidden', isActive ? 'false' : 'true');
      if (isActive) {
        slides[i].removeAttribute('tabindex');
        setSlideInert(slides[i], false);
      } else {
        slides[i].setAttribute('tabindex', '-1');
        setSlideInert(slides[i], true);
      }

      dot.addEventListener('click', () => {
        activateDot(dot, i);
      });

      dot.addEventListener('keydown', (ev) => {
        let newIndex = null;
        if (ev.key === 'ArrowRight') newIndex = (i + 1) % dots.length;
        else if (ev.key === 'ArrowLeft') newIndex = (i - 1 + dots.length) % dots.length;
        else if (ev.key === 'Home') newIndex = 0;
        else if (ev.key === 'End') newIndex = dots.length - 1;

        if (newIndex !== null) {
          ev.preventDefault();
          activateDot(dots[newIndex], newIndex);
          dots[newIndex].focus();
          return;
        }

        if (ev.key === 'Enter' || ev.key === ' ') {
          ev.preventDefault();
          activateDot(dot, i);
        }
      });
    });
    [leftArrow, rightArrow].forEach((btn) => {
      if (!btn) return;
      btn.addEventListener('click', () => {
        pauseAutoplay();
        setPlayPauseUI(true);
      });
      btn.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          pauseAutoplay();
          setPlayPauseUI(true);
        }
      });
    });
    slider.addEventListener('pointerdown', () => {
      pauseAutoplay();
      setPlayPauseUI(true);
    }, { passive: true });
    slider.addEventListener('focusin', () => {
      pauseAutoplay();
      setPlayPauseUI(true);
    });
    const syncAccessibility = () => {
      slides.forEach((panel, i) => {
        const active = panel.classList.contains('active');
        dots[i].setAttribute('aria-selected', active ? 'true' : 'false');
        dots[i].setAttribute('tabindex', active ? '0' : '-1');
        panel.setAttribute('aria-hidden', active ? 'false' : 'true');
        if (active) {
          panel.removeAttribute('tabindex');
          setSlideInert(panel, false);
        } else {
          panel.setAttribute('tabindex', '-1');
          setSlideInert(panel, true);
        }
      });
    };
    const itemsContainer = slider.querySelector('.big-slider__items');
    if (itemsContainer) {
      const mo = new MutationObserver(syncAccessibility);
      mo.observe(itemsContainer, { attributes: true, subtree: true, attributeFilter: ['class'] });
      slider.__a11y_mutationObserver = mo;
    }

    syncAccessibility();
    setPlayPauseUI(slider.dataset.a11yPaused === 'true');
    if (hasAuto && slider.dataset.a11yPaused !== 'true' && typeof slider.__a11y_originalStartAutoplay === 'function') {
      safeClearTimeout(slider.slider);
      slider.__a11y_originalStartAutoplay();
    }
  });
}

// fix for Af-48
// function fieldsetForPurchaseOptions() {
//   const applyFix = (root = document) => {
//     const titles = root.querySelectorAll('.appstle_widget_title:not(legend)');
//     let changed = false;
//     titles.forEach(titleDiv => {
//       if (!titleDiv.parentElement) return;
//       const container = titleDiv.parentElement;
//       const fieldset = document.createElement('fieldset');
//       const legend = document.createElement('legend');
//       legend.className = titleDiv.className;
//       legend.textContent = titleDiv.textContent;
//       fieldset.appendChild(legend);
//       const elementsToMove = [];
//       let nextElement = titleDiv.nextElementSibling;
//       while (
//         nextElement &&
//         (nextElement.classList.contains('appstle_subscription_wrapper') ||
//          nextElement.classList.contains('appstle_subscription_wrapper_option'))
//       ) {
//         elementsToMove.push(nextElement);
//         nextElement = nextElement.nextElementSibling;
//       }
//       if (elementsToMove.length > 0) {
//         elementsToMove.forEach(el => fieldset.appendChild(el));
//         container.insertBefore(fieldset, titleDiv);
//         container.removeChild(titleDiv);
//         changed = true;
//       }
//     });
//     return changed;
//   };
//   const observer = new MutationObserver(mutationsList => {
//     for (const mutation of mutationsList) {
//       mutation.addedNodes.forEach(node => {
//         if (node.nodeType === 1) {
//           if (applyFix(node)) {
//           }
//         }
//       });
//     }
//   });

//   observer.observe(document.body, {
//     childList: true,
//     subtree: true
//   });
//   applyFix();
// }

function fieldsetForPurchaseOptions() {
  const applyFix = (root = document) => {
    const titles = root.querySelectorAll('.appstle_widget_title:not(legend)');
    let changed = false;

    titles.forEach(titleDiv => {
      if (!titleDiv.parentElement) return;

      const container = titleDiv.parentElement;
      const fieldset = document.createElement('fieldset');
      const legend = document.createElement('legend');
      legend.className = titleDiv.className;
      legend.textContent = titleDiv.textContent;
      fieldset.appendChild(legend);

      const elementsToMove = [];
      let nextElement = titleDiv.nextElementSibling;

      while (
        nextElement &&
        (nextElement.classList.contains('appstle_subscription_wrapper') ||
          nextElement.classList.contains('appstle_subscription_wrapper_option'))
      ) {
        elementsToMove.push(nextElement);
        nextElement = nextElement.nextElementSibling;
      }

      if (elementsToMove.length > 0) {
        elementsToMove.forEach(el => {
          const selectEl = el.querySelector('select');
          if (selectEl && !el.querySelector('.frequency-label')) {
            const label = document.createElement('label');
            label.className = 'frequency-label';
            label.textContent = 'Frequency of delivery :';
            if (selectEl.id) label.setAttribute('for', selectEl.id);
            selectEl.parentNode.insertBefore(label, selectEl);
          }
          fieldset.appendChild(el);
        });

        container.insertBefore(fieldset, titleDiv);
        container.removeChild(titleDiv);
        changed = true;
      }
    });

    return changed;
  };

  const observer = new MutationObserver(mutationsList => {
    for (const mutation of mutationsList) {
      mutation.addedNodes.forEach(node => {
        if (node.nodeType === 1) {
          if (applyFix(node)) {
          }
        }
      });
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  applyFix();
}

// Fix for Af-41
function fixSortByCombobox() {
  const ACTIVE_CLASS = 'boost-sd__sorting-option--active';
  const FOCUS_CLASS = 'boost-sd__sorting-option--focus';
  let uid = 0;

  const ensureId = (el, base) => {
    if (!el) return '';
    if (el.id) return el.id;
    uid += 1;
    el.id = `${base}-${uid}`;
    return el.id;
  };

  const enhanceOnce = (docRoot) => {
    const wrapper = docRoot.querySelector('.boost-sd__sorting-label-wrapper');
    const list = docRoot.querySelector('.boost-sd__sorting-list');
    const toggleButton = docRoot.querySelector('.boost-sd__sorting-button');
    if (!wrapper || !list || wrapper.dataset.a11yEnhanced === 'true') return;
    const options = Array.from(list.querySelectorAll('.boost-sd__sorting-option'));
    if (!options.length) return;
    const valueSpan = wrapper.querySelector('.boost-sd__sorting-value') || wrapper;
    const labelSpan = wrapper.querySelector('.boost-sd__sorting-label');
    const listId = ensureId(list, 'boost-sd-listbox');
    ensureId(valueSpan, 'boost-sd-combobox');
    if (labelSpan) labelSpan.id = labelSpan.id || 'boost-sd-sorting-label';
    valueSpan.setAttribute('role', 'combobox');
    valueSpan.setAttribute('tabindex', '0');
    valueSpan.setAttribute('aria-haspopup', 'listbox');
    valueSpan.setAttribute('aria-controls', listId);
    valueSpan.setAttribute('aria-expanded', 'false');
    valueSpan.setAttribute('aria-readonly', 'true');
    if (labelSpan) valueSpan.setAttribute('aria-labelledby', labelSpan.id);
    list.setAttribute('role', 'listbox');
    options.forEach((opt) => {
      ensureId(opt, 'boost-sd-option');
      opt.setAttribute('role', 'option');
      opt.setAttribute('aria-selected', String(opt.classList.contains(ACTIVE_CLASS)));
      opt.classList.remove(FOCUS_CLASS);
      opt.style.boxShadow = '';
    });

    let index = options.findIndex(o => o.classList.contains(ACTIVE_CLASS));
    if (index < 0) index = 0;

    const updateFocus = (i) => {
      options.forEach((o, idx) => {
        o.classList.toggle(FOCUS_CLASS, idx === i);
        o.style.border = idx === i ? '2px solid black' : '';
        o.setAttribute('aria-selected', String(idx === i));
      });
      index = i;
      valueSpan.setAttribute('aria-activedescendant', options[i].id);
    };

    updateFocus(index);
    const isListOpen = () => {
      const cs = window.getComputedStyle(list);
      return cs.display !== 'none' && cs.visibility !== 'hidden' && cs.opacity !== '0';
    };

    const syncExpandedAttr = () => {
      requestAnimationFrame(() => {
        valueSpan.setAttribute('aria-expanded', String(isListOpen()));
      });
    };

    const openList = () => {
      if (!isListOpen() && toggleButton) toggleButton.click();
      syncExpandedAttr();
    };
    const closeList = () => {
      if (isListOpen() && toggleButton) toggleButton.click();
      syncExpandedAttr();
    };
    const haltKey = (e) => {
      e.preventDefault();
      e.stopPropagation();
      if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();
    };
    const onKeyDown = (e) => {
      const opts = options;
      if (!opts.length) return;

      switch (e.key) {
        case 'ArrowDown':
          e.preventDefault();
          updateFocus((index + 1) % opts.length);
          openList();
          break;
        case 'ArrowUp':
          e.preventDefault();
          updateFocus((index - 1 + opts.length) % opts.length);
          openList();
          break;
        case 'Home':
          e.preventDefault();
          updateFocus(0);
          openList();
          break;
        case 'End':
          e.preventDefault();
          updateFocus(opts.length - 1);
          openList();
          break;
        case 'Enter':
        case ' ':
          haltKey(e);
          openList();
          if (isListOpen() && options[index]) {
            options[index].click(); 
            closeList();
          }
          break;
        case 'Escape':
          haltKey(e);
          closeList();
          valueSpan.focus();
          break;
        case 'Tab':
          closeList();
          break;
      }
    };
    const onKeyUp = (e) => {
      if (e.key === ' ' || e.key === 'Escape' || e.key === 'Enter') {
        haltKey(e);
      }
    };

    valueSpan.addEventListener('keydown', onKeyDown);
    valueSpan.addEventListener('keyup', onKeyUp);
    valueSpan.addEventListener('blur', () => {
      closeList();
    });
    const onClickOutside = (e) => {
      if (!wrapper.contains(e.target) && !list.contains(e.target)) {
        closeList();
      }
    };
    document.addEventListener('mousedown', onClickOutside);
    const syncObserver = new MutationObserver(() => {
      options.forEach((o) => {
        o.setAttribute('aria-selected', String(o.classList.contains(ACTIVE_CLASS)));
      });
    });
    syncObserver.observe(list, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });

    wrapper.dataset.a11yEnhanced = 'true';
  };
  enhanceOnce(document);
  const observer = new MutationObserver(() => enhanceOnce(document));
  observer.observe(document.body, { childList: true, subtree: true });
}

// AF-53
function observePortalImageAlt() {
  const observer = new MutationObserver(() => {
    const imgEl = document.querySelector(
      "#appstleSubscriptionCustomerPortal img.as-w-14"
    );
    if (imgEl) {
      imgEl.setAttribute("alt", "");
    }
  });
  observer.observe(document.body, { childList: true, subtree: true });
}

// Fix for AF-21
function enhanceCTAs() {
  document.querySelectorAll('.as-cta').forEach(el => {
      el.setAttribute('role', 'button');
      el.setAttribute('tabindex','0');
  });
}

// Fix for Af-55 and AF-23
function fixContractActionList() {
  const container = document.querySelector(
    ".appstle-contract-cancel-and-detail-wrapper"
  );
  if (!container) return;
  if (container.dataset.listFixed) return;
  container.setAttribute("role", "list");
  const children = Array.from(container.children);
  children.forEach((child) => {
    if (child.getAttribute("role") === "listitem" || child.closest('[role="listitem"]')) {
      return;
    }
    const wrapper = document.createElement("div");
    wrapper.setAttribute("role", "listitem");
    wrapper.style.display = "contents";
    wrapper.appendChild(child);
    container.insertBefore(wrapper, child.nextSibling);
  });
  container.dataset.listFixed = "1";
}

function initObserverForPortal() {
  const observer = new MutationObserver(() => {
    const portal = document.querySelector("#appstleSubscriptionCustomerPortal");
    if (portal) {
      observePortalImageAlt();
      enhanceCTAs();
       fixContractActionList();
      const targetButton = portal.querySelector(
        "#appstleSubscriptionCustomerPortal > div > div > div > div > div > div > div.as-rounded-lg.as-border.lg\\:as-border-0.as-border-gray-200.as-bg-white.as-shadow.as-overflow-hidden.sm\\:as-rounded-lg.as-my-8.as-card.as-subscription.active > div.as-px-2.as-py-3.md\\:as-px-4.md\\:as-py-5.sm\\:as-px-6.as-justify-between.as-flex-col.md\\:as-flex-row.as-items-center.as-subscription-footer > div.appstle-contract-action-wrapper.as-flex.as-flex-col.lg\\:as-flex-row.as-justify-between > div.as-grid.as-grid-cols-2.lg\\:as-grid-cols-3.as-gap-x-2.lg\\:as-flex.as-items-center.md\\:as-grid-cols-2.lg\\:as-ml-auto.appstle-contract-cancel-and-detail-wrapper.as-flex-row.as-flex-wrap  a > button"
      );
      if (targetButton && !targetButton.hasAttribute("data-role-fixed")) {
        targetButton.setAttribute("role", "none");
        targetButton.setAttribute("data-role-fixed", "true");
        targetButton.setAttribute('tabindex','-1');
      }
    }
  });
  observer.observe(document.body, { childList: true, subtree: true });
}
// Fix for Af-52 AF-25 AF-26 AF-47 and AF-53
function observePortalProducts() {
  const scan = () => {
    const roots = [
      document.getElementById("headlessui-portal-root"),
      document.getElementById("appstleSubscriptionCustomerPortal")
    ].filter(Boolean);
    const selectorsForRemoval = 'div.as-edit-frequency > h4, .as-edit-frequency > h4';
    const removeEditFreqHeaders = (scope) => {
      if (!scope) return;
      scope.querySelectorAll(selectorsForRemoval).forEach(h => h.remove());
      scope.querySelectorAll('*').forEach(el => {
        if (el && el.shadowRoot) {
          try {
            el.shadowRoot.querySelectorAll(selectorsForRemoval).forEach(h => h.remove());
          } catch (e) {
          }
        }
      });
    };
    roots.forEach((root) => {
      const searchInput = root.querySelector('input.as-add-product-search-input');
      if (searchInput) {
        const priorNotice = searchInput.parentNode.querySelector('p.visually-hidden[data-ae="product-search-notice"]');
        if (!priorNotice) {
          const hiddenNotice = document.createElement("p");
          hiddenNotice.className = "visually-hidden";
          hiddenNotice.setAttribute("data-ae", "product-search-notice");
          hiddenNotice.textContent = "Searching here will update the product list below.";
          searchInput.parentNode.insertBefore(hiddenNotice, searchInput);
          const label = document.createElement("label");
          label.textContent = "Search Products";
          label.setAttribute("for", searchInput.id || "as-search-products-input");
          if (!searchInput.id) {
            searchInput.id = "as-search-products-input";
          }
          hiddenNotice.insertAdjacentElement("afterend", label);
        }
      }
      const anchors = root.querySelectorAll("p.as-text-sm a.as-product-title-tag-a");
      const buttons = root.querySelectorAll("button.as-product-card-button");
      anchors.forEach((anchor, index) => {
        let anchorId = anchor.getAttribute("id");
        if (!anchorId) {
          anchorId = `product-title-${index + 1}`;
          anchor.setAttribute("id", anchorId);
        }
        const btn = buttons[index];
        if (btn) {
          let btnId = btn.getAttribute("id");
          if (!btnId) {
            btnId = `product-btn-${index + 1}`;
            btn.setAttribute("id", btnId);
          }
          btn.setAttribute("aria-labelledby", `${btnId} ${anchorId}`);
        }
      });
      const imageAnchors = root.querySelectorAll("a img");
      imageAnchors.forEach((img) => {
        const anchor = img.closest("a");
        if (anchor) {
          anchor.setAttribute("role", "none");
          anchor.setAttribute("tabindex", "-1");
          img.setAttribute("alt", "");
        }
      });
      const upsellSelector = '#headlessui-tabs-panel-\\:r3\\: > div > div.lg\\:as-col-span-8.as-full-width.as-panel-left > div.as-upsell-products.as-hidden.lg\\:as-block > div > div > div > div.as-flex.as-justify-between.as-flex-col.lg\\:as-flex-row > div > div > button';
      const dialogSelector = 'div.as-modal-body.as-overflow-y-scroll.as-bg-gray-100 > div > div > div.as-flex.as-justify-between.as-flex-col.lg\\:as-flex-row > div > div > button';
      let btn = null;
      if (root.id === 'headlessui-portal-root') {
        btn = root.querySelector(upsellSelector);
      } else if (root.id === 'appstleSubscriptionCustomerPortal') {
        btn = root.querySelector(dialogSelector);
      }
      if (!btn) {
        btn = root.querySelector(upsellSelector) || root.querySelector(dialogSelector);
      }
      if (btn) {
        btn.setAttribute("role", "none");
        btn.setAttribute("tabindex", "-1");
      }
      removeEditFreqHeaders(root);
    });
  };

  const observer = new MutationObserver(scan);
  observer.observe(document.body, { childList: true, subtree: true });
  scan();
}

// Fix for AF-50
function markDecorativeHeadings(stage) {
  if (!stage) return;
  const headings = stage.querySelectorAll("h5.brand-slider-text");
  headings.forEach(h5 => {
    h5.setAttribute("role", "none");
  });
}

function initBrandsCarousel(selector, urlMatch) {
  if (urlMatch && !location.href.includes(urlMatch)) return null;

  const carousel = document.querySelector(selector);
  if (!carousel) return null;
  window.__brandsCarouselState = window.__brandsCarouselState || {};
  if (window.__brandsCarouselState[selector]) {
    return window.__brandsCarouselState[selector].handle;
  }
  const stateKey = 'brands:' + selector;

  function hasActiveClass(el) {
    if (!el) return false;
    if (el.classList?.contains('active')) return true;
    const cn = el.className || '';
    return /\bactive\b/.test(cn);
  }

  function onTabKeydown(e) {
    const tabs = Array.from(
      carousel.querySelectorAll(`.owl-dots[data-brands-play="${stateKey}"] button[role="tab"]`)
    );
    const currentIndex = tabs.indexOf(document.activeElement);
    if (currentIndex === -1) return;

    let newIndex = null;
    if (e.key === "ArrowRight" || e.key === "ArrowDown") {
      newIndex = (currentIndex + 1) % tabs.length;
    } else if (e.key === "ArrowLeft" || e.key === "ArrowUp") {
      newIndex = (currentIndex - 1 + tabs.length) % tabs.length;
    } else if (e.key === "Home") {
      newIndex = 0;
    } else if (e.key === "End") {
      newIndex = tabs.length - 1;
    } else if (e.key === "Tab" && !e.shiftKey) {
      e.preventDefault();
      const stage = carousel.querySelector('.owl-stage');
      const activeItem = stage?.querySelector('.owl-item.active');
      if (activeItem) {
        const focusable = activeItem.querySelector(
          'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
        );
        if (focusable) {
          focusable.focus();
          return;
        }
      }
      if (stage) stage.focus();
      return;
    }
    if (newIndex !== null) {
      e.preventDefault();
      tabs[newIndex].focus();
      tabs[newIndex].click();
    }
  }

  function onPlayPauseClick(e) {
    const btn = e.currentTarget;
    const isPaused = btn.getAttribute('aria-pressed') === 'true';
    if (isPaused) {
      try { if (window.jQuery) $(carousel).trigger('play.owl.autoplay', [1000]); } catch {}
      btn.setAttribute('aria-pressed', 'false');
      btn.setAttribute('aria-label', 'Pause slideshow');
      btn.innerHTML = '<span aria-hidden="true" class="icon">❚❚</span>';
    } else {
      try { if (window.jQuery) $(carousel).trigger('stop.owl.autoplay'); } catch {}
      btn.setAttribute('aria-pressed', 'true');
      btn.setAttribute('aria-label', 'Play slideshow');
      btn.innerHTML = '<span aria-hidden="true" class="icon">▶</span>';
    }
  }

  function ensureSinglePlayPause() {
    const parent = carousel.parentNode;
    if (!parent) return null;
    const all = Array.from(document.querySelectorAll(`button.carousel-toggle[data-brands-play="${stateKey}"]`));
    if (all.length >= 1) {
      const btn = all[0];
      if (!btn.dataset.handlerAttached) {
        btn.addEventListener('click', onPlayPauseClick);
        btn.dataset.handlerAttached = '1';
      }
      return btn;
    }
    const playPauseBtn = document.createElement('button');
    playPauseBtn.classList.add('carousel-toggle');
    playPauseBtn.setAttribute('data-brands-play', stateKey);
    playPauseBtn.setAttribute('aria-pressed', 'false');
    playPauseBtn.setAttribute('aria-label', 'Pause slideshow');
    playPauseBtn.setAttribute('type', 'button');
    playPauseBtn.innerHTML = '<span aria-hidden="true" class="icon">❚❚</span>';
    playPauseBtn.addEventListener('click', onPlayPauseClick);
    playPauseBtn.dataset.handlerAttached = '1';

    parent.insertBefore(playPauseBtn, carousel);
    return playPauseBtn;
  }

  function enforceBrandImageRules() {
    const anchors = carousel.querySelectorAll('.brand-slider-image-wrapper a');
    for (const anchor of anchors) {
      anchor.setAttribute('role', 'none');
      anchor.setAttribute('tabindex', '-1');
      const imgs = anchor.querySelectorAll('img');
      for (const img of imgs) {
        img.setAttribute('alt', '');
      }
    }
  }

  function setupStructure() {
    const stageOuter = carousel.querySelector('.owl-stage-outer');
    const dots = carousel.querySelector('.owl-dots');
    if (!stageOuter || !dots) return;
    if (dots.nextElementSibling !== stageOuter) {
      stageOuter.parentNode.insertBefore(dots, stageOuter);
    }
    dots.setAttribute('role', 'tablist');
    dots.setAttribute('aria-label', 'Brand carousel navigation');
    dots.setAttribute('data-brands-play', stateKey);
    dots.removeEventListener('keydown', onTabKeydown);
    dots.addEventListener('keydown', onTabKeydown);
    ensureSinglePlayPause();
  }

  function syncAccessibility() {
    const items = Array.from(carousel.querySelectorAll('.owl-item'));
    if (!items.length) return;
    const dotsContainer = carousel.querySelector(`.owl-dots[data-brands-play="${stateKey}"]`) || carousel.querySelector('.owl-dots');
    const dotBtns = dotsContainer ? Array.from(dotsContainer.querySelectorAll('button')) : [];
    const stage = carousel.querySelector('.owl-stage');
    if (stage) {
      const stageId = stage.id || `${stateKey}-stage`;
      stage.id = stageId;
      stage.setAttribute('role', 'tabpanel');
      const active = items.some(item => hasActiveClass(item));
      stage.setAttribute('aria-hidden', String(!active));
      items.forEach((item) => {
        const activeItem = hasActiveClass(item);
        if (activeItem) {
          Array.from(item.querySelectorAll('a, button, input, [tabindex]'))
            .forEach(el => el.removeAttribute('tabindex'));
        } else {
          Array.from(item.querySelectorAll('a, button, input, [tabindex]'))
            .forEach(el => el.setAttribute('tabindex', '-1'));
        }
      });
      dotBtns.forEach((dot, index) => {
        dot.setAttribute('role', 'tab');
        dot.id = dot.id || `${stateKey}-tab-${index}`;
        dot.setAttribute('aria-controls', stageId);
        const total = dotBtns.length;
        const pos = index + 1;
        const baseLabel = dot.textContent.trim() || `Tab ${pos}`;
        dot.setAttribute('aria-label', `${baseLabel} of ${total}`);
        const dotActive = hasActiveClass(dot) || (items[index] && hasActiveClass(items[index]));
        if (dotActive) {
          dot.setAttribute('aria-selected', 'true');
          dot.removeAttribute('tabindex');
        } else {
          dot.setAttribute('aria-selected', 'false');
          dot.setAttribute('tabindex', '-1');
        }
      });
      if (typeof markDecorativeHeadings === "function") {
        markDecorativeHeadings(stage);
      }
    }
  }

  let rafId = null;
  function scheduleSync() {
    if (rafId) cancelAnimationFrame(rafId);
    rafId = requestAnimationFrame(() => {
      rafId = null;
      setupStructure();
      syncAccessibility();
      enforceBrandImageRules();
    });
  }

  setupStructure();
  syncAccessibility();
  enforceBrandImageRules();

  const observer = new MutationObserver((mutations) => {
    let need = false;
    for (const m of mutations) {
      if (m.type === 'childList') { need = true; break; }
      if (m.type === 'attributes' && m.attributeName === 'class') { need = true; break; }
    }
    if (need) scheduleSync();
  });

  observer.observe(carousel, { subtree: true, childList: true, attributes: true, attributeFilter: ['class'] });

  function owlHandler() { scheduleSync(); }
  if (window.jQuery && typeof $(carousel).on === 'function') {
    $(carousel).on('changed.owl.carousel initialized.owl.carousel refreshed.owl.carousel', owlHandler);
  }

  const handle = {
    disconnect() {
      observer.disconnect();
      if (rafId) { cancelAnimationFrame(rafId); rafId = null; }
      if (window.jQuery && typeof $(carousel).off === 'function') {
        $(carousel).off('changed.owl.carousel initialized.owl.carousel refreshed.owl.carousel', owlHandler);
      }
      const btn = document.querySelector(`button.carousel-toggle[data-brands-play="${stateKey}"]`);
      if (btn && btn.parentNode) btn.parentNode.removeChild(btn);
      delete window.__brandsCarouselState[selector];
    }
  };

  window.__brandsCarouselState[selector] = { handle };
  return handle;
}

// Fix for AF-33
function applyAltsToMultipleSliders({
  sliderSelectors = [],
  altArrays = [],
  overwrite = false
} = {}) {
  if (!Array.isArray(sliderSelectors) || !Array.isArray(altArrays)) {
    return;
  }

  if (sliderSelectors.length !== altArrays.length) {
    return;
  }

  sliderSelectors.forEach((sliderSelector, sliderIndex) => {
    const altArray = altArrays[sliderIndex];
    if (!Array.isArray(altArray) || altArray.length === 0) {
      return;
    }
    const slider = document.querySelector(sliderSelector);
    if (!slider) {
      return;
    }

    const anchors = Array.from(slider.querySelectorAll('a[href]'));
    anchors.forEach((anchor, index) => {
      const altText = altArray[index];
      if (!altText) return;

      const img = anchor.querySelector('img');
      if (img) {
        const currentAlt = img.getAttribute('alt');
        const isEmptyAlt = currentAlt === null || currentAlt.trim() === '';
        if (overwrite || isEmptyAlt) {
          img.setAttribute('alt', altText);
        }
      } else {
        if (!anchor.hasAttribute('aria-label') || overwrite) {
          anchor.setAttribute('aria-label', altText);
        }
      }
    });
  });
}

function initPaginationButtonObserver(targetUrl) {
  if (!window.location.href.includes(targetUrl)) return;
  const setAria = (btn, label) => {
    if (btn && btn.getAttribute('aria-label') !== label) {
      btn.setAttribute('aria-label', label);
    }
  };
  const addAriaLabels = () => {
    setAria(document.querySelector('button.boost-sd__pagination-button--prev'), 'Previous');
    setAria(document.querySelector('button.boost-sd__pagination-button--next'), 'Next');
  };
  addAriaLabels();
  const paginationRoot = document.querySelector('.boost-sd__sorting') 
    || document.body; 
  const observer = new MutationObserver(() => addAriaLabels());
  observer.observe(paginationRoot, {
    childList: true,
    subtree: true
  });

  return observer;
}

// Fix for AF-32 and AF-22
function initFilterOptionsObserver() {
  const observedLabels = new WeakSet();
  const observedWrappers = new WeakSet();

  const updateAriaExpanded = (labelEl) => {
    const button = labelEl.querySelector('button.boost-sd__filter-option-title');
    if (!button) return;

    const isCollapsed = labelEl.classList.contains('boost-sd__filter-option-label--collapsed');
    button.setAttribute('aria-expanded', String(!isCollapsed));
  };

  const updateInert = (itemWrapper) => {
    const isCollapsed = itemWrapper.classList.contains('boost-sd__filter-option-itemwrapper--collapsed');
    if (isCollapsed) {
      itemWrapper.setAttribute('inert', '');
    } else {
      itemWrapper.removeAttribute('inert');
    }
  };

  const observeLabel = (labelEl) => {
    if (observedLabels.has(labelEl)) return;
    observedLabels.add(labelEl);

    updateAriaExpanded(labelEl);

    const labelObserver = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        if (mutation.attributeName === 'class') {
          updateAriaExpanded(labelEl);
        }
      }
    });

    labelObserver.observe(labelEl, { attributes: true, attributeFilter: ['class'] });
  };

  const observeItemWrapper = (itemWrapper) => {
    if (observedWrappers.has(itemWrapper)) return;
    observedWrappers.add(itemWrapper);

    updateInert(itemWrapper);

    const wrapperObserver = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        if (mutation.attributeName === 'class') {
          updateInert(itemWrapper);
        }
      }
    });

    wrapperObserver.observe(itemWrapper, { attributes: true, attributeFilter: ['class'] });
  };

  const initElements = () => {
    const labels = document.querySelectorAll('.boost-sd__filter-option-label');
    labels.forEach(observeLabel);

    const wrappers = document.querySelectorAll('.boost-sd__filter-option-itemwrapper');
    wrappers.forEach(observeItemWrapper);
  };

  initElements();

  const globalObserver = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType !== 1) return;

        if (node.matches('.boost-sd__filter-option-label')) {
          observeLabel(node);
        } else {
          const nestedLabels = node.querySelectorAll?.('.boost-sd__filter-option-label') || [];
          nestedLabels.forEach(observeLabel);
        }

        if (node.matches('.boost-sd__filter-option-itemwrapper')) {
          observeItemWrapper(node);
        } else {
          const nestedWrappers = node.querySelectorAll?.('.boost-sd__filter-option-itemwrapper') || [];
          nestedWrappers.forEach(observeItemWrapper);
        }
      });
    }
  });

  globalObserver.observe(document.body, { childList: true, subtree: true });

  return globalObserver;
}

function disableHcaptchaBadge() {
  const badge = document.querySelector('#shop-hcaptcha-badge-container');
  if (badge) {
    badge.setAttribute('inert', '');
    return;
  }
  const observer = new MutationObserver((mutations, obs) => {
    const badge = document.querySelector('#shop-hcaptcha-badge-container');
    if (badge) {
      badge.setAttribute('inert', '');
      obs.disconnect();
    }
  });
  observer.observe(document.body, { childList: true, subtree: true });
}

// Fix for AF-31
function linkButtonsToHeadings() {
  const selectors = ['blog-posts', 'featured-collection'];
  selectors.forEach((sectionName) => {
    document.querySelectorAll(`div[data-section-name="${sectionName}"]`).forEach((container, i) => {
      const heading = container.querySelector('h2.mt0');
      const btn = container.querySelector('a.btn-small, a.btn'); 
      if (!heading || !btn) return;
      const headingId = `${sectionName}-heading-${i+1}`;
      const btnId = `${sectionName}-btn-${i+1}`;
      heading.id = headingId;
      btn.id = btnId;
      btn.setAttribute('aria-labelledby', `${btnId} ${headingId}`);
    });
  });
}

// Fix for AF-23
function fixStoreHoursTable() {
  const defaultSel = "#shopify-section-template--18977245724860__main > div > div > div > table";
  const table = document.querySelector(defaultSel);
  if (!table) return;
  if (table.dataset.hoursConverted) return;

  table.querySelectorAll("td").forEach((td) => {
    if (td.dataset.hoursConverted) return;

    const strong = td.querySelector("strong");
    let h2El = null;

    if (strong) {
      const headingText = strong.textContent.trim();
      const computed = window.getComputedStyle(strong);
      h2El = document.createElement("h2");
      h2El.className = "hours-heading";
      h2El.textContent = headingText;
      h2El.style.fontWeight = computed.fontWeight;
      h2El.style.fontSize = computed.fontSize;
      h2El.style.fontFamily = computed.fontFamily;
      h2El.style.lineHeight = computed.lineHeight;
      h2El.style.color = computed.color;
      h2El.style.margin = "0";
      h2El.style.padding = "0";
      h2El.style.display = "block";

      strong.replaceWith(h2El);
    }

    const anchor = td.querySelector("h2.hours-heading") || td.querySelector("h2") || null;
    let node = anchor ? anchor.nextSibling : td.firstChild;
    const segments = [];
    let buffer = "";

    while (node) {
      if (node.nodeType === Node.ELEMENT_NODE && node.tagName.toLowerCase() === "br") {
        if (buffer.trim()) segments.push(buffer.trim());
        buffer = "";
      } else if (node.nodeType === Node.TEXT_NODE) {
        buffer += node.textContent;
      } else if (node.nodeType === Node.ELEMENT_NODE) {
        if (node.querySelector && node.querySelector("br")) {
          const parts = node.outerHTML.split(/<br\b[^>]*>/i);
          buffer += parts.shift() || "";
          parts.forEach((p) => {
            if (buffer.trim()) segments.push(buffer.trim());
            buffer = p || "";
          });
        } else {
          buffer += node.outerHTML;
        }
      }
      node = node.nextSibling;
    }

    if (buffer.trim()) segments.push(buffer.trim());

    if (h2El && segments.length) {
      const firstClean = segments[0].replace(/<\/?[^>]+>/g, "").trim();
      if (firstClean && firstClean === h2El.textContent.trim()) {
        segments.shift();
      }
    }

    if (segments.length) {
      const ul = document.createElement("ul");
      ul.className = "hours-list";

      segments.forEach((seg) => {
        const li = document.createElement("li");
        li.innerHTML = seg;
        ul.appendChild(li);
      });

      const headingClone = h2El ? h2El.cloneNode(true) : null;
      td.innerHTML = "";
      if (headingClone) td.appendChild(headingClone);
      td.appendChild(ul);
    }

    td.dataset.hoursConverted = "1";
  });

  table.dataset.hoursConverted = "1";
  return true;
}

function transformShadowDomMenu() {
  const ROOT_SELECTOR = '#MainContent > accounts-hub';
  let shadowObserver = null;
  let debounceTimer = null;

  function processShadow(shadow) {
    if (!shadow) return;
    [
      { sel: '.heading-md', lvl: 2 },
      { sel: '.main-hd', lvl: 2 },
      { sel: '.i-hd-t', lvl: 3 },
    ].forEach(({ sel, lvl }) => {
      shadow.querySelectorAll(sel).forEach(el => {
        if (!el.hasAttribute('role')) el.setAttribute('role', 'heading');
        if (!el.hasAttribute('aria-level')) el.setAttribute('aria-level', String(lvl));
      });
    });

    const innerMenu = shadow.querySelector('#menuItems .inner-menu');
    if (!innerMenu) return;

    if (innerMenu.getAttribute('role') !== 'list') {
      innerMenu.setAttribute('role', 'list');
    }
    innerMenu.querySelectorAll('a').forEach(anchor => {
      if (anchor.closest('[role="listitem"]')) return;

      const wrapper = document.createElement('div');
      wrapper.setAttribute('role', 'listitem');
      anchor.parentElement.insertBefore(wrapper, anchor);
      wrapper.appendChild(anchor);
    });
    innerMenu.querySelectorAll('a').forEach(anchor => {
      if (anchor.href === window.location.href) {
        anchor.setAttribute('aria-current', 'page');
      } else {
        anchor.removeAttribute('aria-current');
      }
    });
    const phoneGroup = shadow.querySelector('.input-group.chHasPhone');
    if (phoneGroup) {
      if (!phoneGroup.querySelector('.cc-label')) {
        const select = phoneGroup.querySelector('select');
        const ccLabel = document.createElement('label');
        ccLabel.className = 'cc-label';
        ccLabel.textContent = 'Country Code';
        ccLabel.setAttribute('for','select-country-code');
        ccLabel.style.cssText = 'align-self:center;top:20%;font-size:12px;left:0%!important;color:#747474';
        phoneGroup.insertBefore(ccLabel, phoneGroup.querySelector('.chCountryCode'));
        select.setAttribute('id','select-country-code');
      }
    }
  }

  function scheduleProcess(shadow) {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(() => processShadow(shadow), 50);
  }
  function attachToHost(host) {
    if (!host || !host.shadowRoot) return;
    const shadow = host.shadowRoot;
    processShadow(shadow);
    if (shadowObserver) shadowObserver.disconnect();
    const menuContainer = shadow.querySelector('#menuItems');
    if (!menuContainer) return;

    shadowObserver = new MutationObserver(() => scheduleProcess(shadow));
    shadowObserver.observe(menuContainer, { childList: true, subtree: true });
  }
  function init() {
    const host = document.querySelector(ROOT_SELECTOR);
    if (host?.shadowRoot) {
      attachToHost(host);
    } else {
      const hostObserver = new MutationObserver(() => {
        const found = document.querySelector(ROOT_SELECTOR);
        if (found?.shadowRoot) {
          attachToHost(found);
          hostObserver.disconnect();
        }
      });
      hostObserver.observe(document.body, { childList: true, subtree: true });
    }
  }
  window.addEventListener('hashchange', () => {
    const host = document.querySelector(ROOT_SELECTOR);
    if (host?.shadowRoot) processShadow(host.shadowRoot);
  });

  init();
}


// Fix for AF-30
function observePrimebImages() {
  if (window.__primebPrimeObserverInit) return;
  const selector = '.insertedprimeb img.primebImage';
  const setAlt = img => img && img.alt !== 'frozen' && (img.alt = 'frozen');
  new MutationObserver(m => {
    m.forEach(x => {
      x.addedNodes.forEach(n => {
        if (n.nodeType !== 1) return;
        if (n.matches?.(selector)) setAlt(n);
        n.querySelectorAll?.(selector).forEach(setAlt);
      });
      if (x.type === 'attributes' && x.target.matches?.(selector)) setAlt(x.target);
    });
  }).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['src','alt','class'] });
  document.querySelectorAll(selector).forEach(setAlt);
  window.__primebPrimeObserverInit = true;
}

// Fix for AF_19
function addAutocompleteInShadow({ timeout = 15000, pollInterval = 200 } = {}) {
  const setAutocomplete = (input, value) => {
    if (input && input.getAttribute('autocomplete') !== value) {
      input.setAttribute('autocomplete', value);
    }
  };

  const applyAutocomplete = () => {
    const accountsHub = document.querySelector('accounts-hub');
    const shadow = accountsHub?.shadowRoot;
    if (!shadow) return false;
    const headings = shadow.querySelectorAll('.has-back');
    headings.forEach(h => {
      h.setAttribute('role', 'heading');
      h.setAttribute('aria-level', '2');
    });
    const profileForm = shadow.querySelector('#ae-holder .widget .content #profile_edit form');
    if (!profileForm) return false;
    setAutocomplete(profileForm.querySelector('input[placeholder="First Name"]'), 'given-name');
    setAutocomplete(profileForm.querySelector('input[placeholder="Last Name"]'), 'family-name');
    setAutocomplete(profileForm.querySelector('input[placeholder="Email"]'), 'email');
    return true;
  };

  let finished = false;
  const cleanup = () => {
    finished = true;
    observer.disconnect();
    clearInterval(pollTimer);
  };

  const tryApply = () => {
    if (finished) return;
    if (applyAutocomplete()) cleanup();
  };

  const observer = new MutationObserver(() => {
    if (!finished) tryApply();
  });
  observer.observe(document.body, { childList: true, subtree: true });

  const start = Date.now();
  const pollTimer = setInterval(() => {
    if (finished) return;
    tryApply();
    if (Date.now() - start > timeout) cleanup();
  }, pollInterval);

  requestAnimationFrame(tryApply);
  if ('requestIdleCallback' in window) {
    requestIdleCallback(tryApply, { timeout: 200 });
  } else {
    setTimeout(tryApply, 50);
  }
}


// Fix for AF-13
function replaceStrongWithH2() {
  const replace = (root) => {
    const tooltip = root.querySelector('.appstle-tootltip-parent');
    if (!tooltip) return;
    const strongEls = tooltip.querySelectorAll('strong');
    strongEls.forEach(strongEl => {
      if (strongEl.textContent.trim() === 'Have complete control of your auto deliveries') {
        const h2 = document.createElement('h2');
        h2.classList.add('tooltip-heading');
        h2.textContent = strongEl.textContent;
        strongEl.replaceWith(h2);
        if (h2.nextSibling && h2.nextSibling.nodeName === 'BR') {
          h2.nextSibling.remove();
        }
      }
    });
  };
  replace(document);
  const observer = new MutationObserver(() => {
    replace(document);
  });
  observer.observe(document.body, { childList: true, subtree: true });
}

function addHeadingRoles() {
  const selectors = [
    '#shopify-section-template--18977244315836__main > article > div > div > div.col-st-12.col-6 > div.article-container.image--radius.heading--mb > p:nth-child(1) > strong:nth-child(3)',
    '#shopify-section-template--18977244315836__main > article > div > div > div.col-st-12.col-6 > div.article-container.image--radius.heading--mb > p:nth-child(1) > strong:nth-child(10)',
    '#shopify-section-template--18977244315836__main > article > div > div > div.col-st-12.col-6 > div.article-container.image--radius.heading--mb > p:nth-child(7) > strong',
    '#shopify-section-template--18977244315836__main > article > div > div > div.col-st-12.col-6 > div.article-container.image--radius.heading--mb > p:nth-child(11) > strong:nth-child(2)',
    '#shopify-section-template--18977244315836__main > article > div > div > div.col-st-12.col-6 > div.article-container.image--radius.heading--mb > p:nth-child(13) > strong:nth-child(4)',
    '#shopify-section-template--18977244315836__main > article > div > div > div.col-st-12.col-6 > div.article-container.image--radius.heading--mb > p:nth-child(15) > strong',
    '#shopify-section-template--18977244315836__main > article > div > div > div.col-st-12.col-6 > div.article-container.image--radius.heading--mb > p:nth-child(16) > strong'
  ];
  selectors.forEach(sel => {
    const el = document.querySelector(sel);
    if (el) {
      el.setAttribute('role', 'heading');
      el.setAttribute('aria-level', '2');
    }
  });
}

// Fix for AF-25
function initProductObserver() {
  const productListSelector =
    '#shopify-block-ATk42NERKNDJzYmxEN__fee6132e-e458-4ac3-a364-bfe4901e638e > div > div > div.boost-sd-layout.boost-sd-layout--has-filter-vertical.boost-sd-layout--has-vertical-style-default > div.boost-sd-right > div.boost-sd__product-list.boost-sd__product-list-grid--3-col.boost-sd__product-list--margin';
  function processProductAnchors(container) {
    const anchors = container.querySelectorAll('a.boost-sd__product-link-image');
    anchors.forEach(anchor => {
      anchor.setAttribute('role', 'none');
      anchor.setAttribute('tabindex', '-1');
      const imgs = anchor.querySelectorAll('img');
      imgs.forEach(img => {
        img.setAttribute('alt', '');
      });
    });
  }
  const existingContainer = document.querySelector(productListSelector);
  if (existingContainer) {
    processProductAnchors(existingContainer);
  }
  const observer = new MutationObserver(mutations => {
    mutations.forEach(mutation => {
      mutation.addedNodes.forEach(node => {
        if (!(node instanceof HTMLElement)) return;
        if (node.matches?.(productListSelector)) {
          processProductAnchors(node);
        }
        if (node.querySelector?.(productListSelector)) {
          const container = node.querySelector(productListSelector);
          if (container) processProductAnchors(container);
        }
        if (node.classList?.contains('boost-sd__product-item')) {
          const parentContainer = node.closest(productListSelector);
          if (parentContainer) processProductAnchors(parentContainer);
        }
      });
    });
  });

  observer.observe(document.body, { childList: true, subtree: true });
}

// Fix for AF-26
function addSearchNotice() {
  const container = document.querySelector(".instant-brand-search");
  if (!container) return;
  if (container.querySelector(".visually-hidden")) return;
  const notice = document.createElement("p");
  notice.className = "visually-hidden";
  notice.textContent = "Search results below will be updated automatically as you type.";
  const input = container.querySelector("input");
  if (input) {
    container.insertBefore(notice, input);
  }
  if (!input.id) {
    input.id = `search-input-${Math.random().toString(36).slice(2, 8)}`;
  }
  if (!container.querySelector(`label[for="${input.id}"]`)) {
        const label = document.createElement("label");
        label.textContent = "Search";
        label.setAttribute("for", input.id);
        container.insertBefore(label, input); 
  }
}

// Fix for AF-16
function setAlt(selector, altText) {
  const img = document.querySelector(selector);
  if (img && img.tagName === "IMG") {
    img.setAttribute("alt", altText);
  }
}

// Fix for AF-38
function insertLabel(targetSelector, labelText) {
    const target = document.querySelector(targetSelector);
    if (!target) return;

    const input = target.querySelector('input, textarea, select');
    if (!input) return;

    if (!input.id) {
        input.id = `input-${Math.random().toString(36).slice(2, 8)}`;
    }

    if (target.querySelector(`label[for="${input.id}"]`)) return;

    const label = document.createElement('label');
    label.setAttribute('for', input.id);
    label.setAttribute('data-generated', 'true');
    label.textContent = labelText;

    target.insertBefore(label, target.firstChild);
}

(function () {
  const SELECTOR = '.boost-sd__pagination-number.boost-sd__pagination-number--circle';
  const ACTIVE_CLASS = 'boost-sd__pagination-number--active';

  function applyColor(el) {
    const color = el.classList.contains(ACTIVE_CLASS) ? '#222222' : '#757575';
    el.style.setProperty('color', color, 'important');
  }

  function updateAll() {
    document.querySelectorAll(SELECTOR).forEach(applyColor);
  }

  const observer = new MutationObserver(mutations => {
    for (const m of mutations) {
      if (m.type === 'attributes') {
        if (m.target.matches(SELECTOR)) applyColor(m.target);
      } else if (m.type === 'childList') {
        m.addedNodes.forEach(n => {
          if (n.nodeType === 1) {
            if (n.matches(SELECTOR)) applyColor(n);
            n.querySelectorAll?.(SELECTOR).forEach(applyColor);
          }
        });
      }
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['class', 'style']
  });

  updateAll();
})();

// function initializePaginationAccessibility() {
//   if (!window.location.href.includes('collections')) {
//     return;
//   }

//   const PAGINATION_SELECTOR = '.boost-sd__pagination.boost-sd__pagination--center';

//   function applyAriaAttributes(paginationElement) {
//     paginationElement.setAttribute('role', 'navigation');
//     paginationElement.setAttribute('aria-label', 'Pagination');

//     const buttons = paginationElement.querySelectorAll('button.boost-sd__pagination-number');
    
//     buttons.forEach(button => {
//       button.removeAttribute('aria-current');

//       if (button.classList.contains('boost-sd__pagination-number--active')) {
//         button.setAttribute('aria-current', 'page');
//       }

//       if (button.classList.contains('boost-sd__pagination-number--disabled')) {
//         button.setAttribute('aria-disabled', 'true');
//         if (button.textContent.includes('...')) {
//           button.setAttribute('aria-label', 'Truncated page list');
//         }
//       } else {
//         button.removeAttribute('aria-disabled');
//       }
//     });
//   }

//   function handleMutations(mutationsList) {
//     for (const mutation of mutationsList) {
//       if (mutation.type === 'childList') {
//         mutation.addedNodes.forEach(node => {
//           if (node.nodeType === Node.ELEMENT_NODE) {
//             if (node.matches(PAGINATION_SELECTOR)) {
//               applyAriaAttributes(node);
//             }
//             node.querySelectorAll(PAGINATION_SELECTOR).forEach(applyAriaAttributes);
//           }
//         });
//       } else if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
//         const paginationParent = mutation.target.closest(PAGINATION_SELECTOR);
//         if (paginationParent) {
//           applyAriaAttributes(paginationParent);
//         }
//       }
//     }
//   }

//   document.querySelectorAll(PAGINATION_SELECTOR).forEach(applyAriaAttributes);

//   const observer = new MutationObserver(handleMutations);
//   observer.observe(document.body, {
//     childList: true,
//     subtree: true,
//     attributes: true,
//     attributeFilter: ['class']
//   });
// }

// if (document.readyState === 'loading') {
//   document.addEventListener('DOMContentLoaded', initializePaginationAccessibility);
// } else {
//   initializePaginationAccessibility();
// }



function enhanceBoostPagination() {
  const PAGINATION_SELECTOR = '.boost-sd__pagination.boost-sd__pagination--center';

  const applyEnhancements = (container) => {
    if (!container || container.dataset.a11yEnhanced === "true") return;

    container.setAttribute('role', 'navigation');
    container.setAttribute('aria-hidden', 'true'); // hide original from screen readers

    // Find existing cloned list wrapper sibling (after the original container)
    let listWrapper = container.parentNode.querySelector('.boost-sd__pagination-a11y');

    if (!listWrapper) {
      listWrapper = document.createElement('ul');
      listWrapper.className = 'boost-sd__pagination-a11y';
      container.insertAdjacentElement('afterend', listWrapper);
    } else {
      // Clear previous clones before adding new ones
      listWrapper.innerHTML = '';
    }

    const cloneButtons = () => {
      const allButtons = Array.from(
        container.querySelectorAll('button.boost-sd__pagination-number, button.boost-sd__pagination-button')
      );

      allButtons.forEach(btn => {
        const li = document.createElement('li');
        const clone = btn.cloneNode(true);

        // Redirect click from clone to original button
        clone.addEventListener('click', e => {
          e.preventDefault();
          btn.click();
        });

        li.appendChild(clone);
        listWrapper.appendChild(li);
      });
    };

    cloneButtons();

    // Observe the original pagination for changes
    const childObserver = new MutationObserver(() => {
      // Clear and re-clone buttons when original changes
      listWrapper.innerHTML = '';
      cloneButtons();
    });

    childObserver.observe(container, { childList: true, subtree: true });

    container.dataset.a11yEnhanced = "true";
  };

  // Initial run for all existing paginations
  document.querySelectorAll(PAGINATION_SELECTOR).forEach(applyEnhancements);

  // Observe body for dynamically added pagination components
  const observer = new MutationObserver(mutations => {
    for (const mutation of mutations) {
      mutation.addedNodes.forEach(node => {
        if (!(node instanceof HTMLElement)) return;

        if (node.matches(PAGINATION_SELECTOR)) {
          applyEnhancements(node);
        } else {
          const innerPaginations = node.querySelectorAll?.(PAGINATION_SELECTOR);
          innerPaginations.forEach(applyEnhancements);
        }
      });
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });
}
/* Hide a11y pagination clone visually, keep for screen readers */
/*.boost-sd__pagination-a11y {
  position: absolute !important;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}*/



window.addEventListener("hashchange", () => {
  initObserverForPortal();
});

document.addEventListener('DOMContentLoaded', function() {
  if (window.location.pathname === "/") {
    insertVisuallyHiddenHeading("Anaheim Feed Store Homepage", "#MainContent");
  }
  if (window.location.href === "https://anaheimfeed.com/pages/verify-your-zipcode") {
    insertVisuallyHiddenHeading("Verify Your Zipcode", "#MainContent");
  }
  if (window.location.href === "https://anaheimfeed.com/blogs/news"){
    insertVisuallyHiddenHeading("Product Education","#MainContent")
  }
  if (window.location.href === "https://anaheimfeed.com/pages/frequent-buyer-help"){
    insertVisuallyHiddenHeading("Frequent Buyer Help","#MainContent");
    addRoleAndAriaLevel();
  }
  if (window.location.href === "https://anaheimfeed.com/pages/monthly-flyer"){
    insertVisuallyHiddenHeading("Monthly Sales Flyer","#MainContent");
  } 
  if (window.location.href === "https://anaheimfeed.com/pages/shop-online-deals"){
    insertVisuallyHiddenHeading("Shop Online Deals","#MainContent");
  }
  if (window.location.href === "https://anaheimfeed.com/pages/store-hours-1"){
    insertVisuallyHiddenHeading("Store Hours","#MainContent");
  }
  if (window.location.href === "https://anaheimfeed.com/pages/location"){
    insertVisuallyHiddenHeading("Location","#MainContent");
  }
  fixHeadings();
  observeElementAndAddZoom();
  linkButtonsToHeadings();
  disableHcaptchaBadge();
  applyAltsToMultipleSliders({
    sliderSelectors: ['#shopify-section-template--18977245102268__brands_JiJXnP > div > div > div > div > slider-component', 
      '#shopify-section-template--18977245102268__brands_VEEeB4 > div > div > div > div > slider-component', 
      '#shopify-section-template--18977245102268__brands_gA6BrU > div > div > div > div > slider-component',
      '#slideshow-template--18977245102268__slideshow_LAih8x > div > div > div > big-slider',
      '#image-banner-template--18977245102268__banners_3LxQzg > div > div'
    ],
     altArrays: [['Shop Puppy','Shop Kitten','Shop Enrichment','Shop Fresh and Frozen','Shop Barkery','Shop Pest Defense'],
    ['Dog','Cat','Small Pet','Pet Bird','Poultry','Wild Bird'],
    ['Nutri Source','Fromm Family pet Food','Orijen','Open Farm','Lucy Pet Foods','Canidae'],
    ['The fresh and Frozen sale 25% off on Frozen raw, Freeze-Dried & Gently Cooked Diets for Dogs and Cats!',
    '25% off on Inaba All Cat and Dog Products',
    'Make Mealtime Meow-worthy with Queen\'s Cat Topers',
    'We Stock Wulfsnacks',
    'Same Day Local Delivery monday-friday only',
    'Auto Delivery never run out of food',
    'CBD oils and treats available.'],
    ['Frozen Delivery to Your Door','Feed Your Pets Healthy Food']],
    overwrite: true
  });
  if (window.location.pathname === '/'){
    initA11yCarouselControls();
  }
  if (window.location.href.includes("customerhub") || window.location.href.includes("apps")) {
    fixReflowForAccountsPage();
    makeModalAccessible('td.as-product-line-amount svg', { debug: true });
    initObserverForPortal();
    observePortalProducts();
    transformShadowDomMenu();
    addAutocompleteInShadow();
  }
  if (window.location.href.includes('pages')) {
    fixIncorrectHeadings();
    brandsPageListMarkup();
    initBrandsCarousel('#slider--AbXVyRjlFeWRLV2xHO__lfs_instant_brand_page_brand_slider_4TGXkY');
  }
  if(window.location.href.includes('collections')) {
    fixSortByCombobox();
    initFilterOptionsObserver();
    initProductObserver();
    observePrimebImages();
    enhanceBoostPagination();
    initPaginationButtonObserver('/collections');
  }
  if(window.location.href.includes('blogs/news')){
    linkButtonsToHeadings();
    addHeadingRoles();
  }
  if(window.location.href.includes('products')) {
    observeTooltipElement();
    fieldsetForPurchaseOptions();
    replaceStrongWithH2();
  }
  if(window.location.href.includes('contact-us-2')){
    fixStoreHoursTable();
  }
  if (window.location.href.includes("/pages/event-calendar")) {
    setAlt("#block-slide_U8biFN > div > img", "Events");
    insertVisuallyHiddenHeading('Event Calendar',"#MainContent");
  }
  if (window.location.href.includes("/pages/how-can-we-help-2")) {
    setAlt("#shopify-section-template--18977245593788__main > div > div > div > img", "FAQ's");
    insertVisuallyHiddenHeading("Frequently Asked Questions","#MainContent");
  }
  if (window.location.href.includes("/pages/frequent-buyer-help")){
    setAlt('#block-slide_dfaTTM > div > picture > img',"Frequent Buyer")
  }
  if(window.location.href.includes('our-brands-2')){
    addSearchNotice();
    insertVisuallyHiddenHeading("Shop By Brands", "#MainContent");
    initBrandsCarousel('#brands\\:\\#slider--AbXVyRjlFeWRLV2xHO__lfs_instant_brand_page_brand_slider_4TGXkY-stage');
  }
  observeAndFocusFirstErrorField();
});
